const e = {
  token_id: "",
  token_policy: "",
  token_ascii: "Cardano",
  is_verified: !0,
  ticker: "ADA"
}, c = {
  token_id: "95a427e384527065f2f8946f5e86320d0117839a5e98ea2c0b55fb0048554e54",
  token_policy: "95a427e384527065f2f8946f5e86320d0117839a5e98ea2c0b55fb00",
  token_ascii: "DexHunter",
  is_verified: !0,
  ticker: "HUNT"
}, d = "000000000000000000000000000000000000000000000000000000006c6f76656c616365", f = {
  "": e,
  undefined: e,
  "000000000000000000000000000000000000000000000000000000006c6f76656c616365": e,
  "95a427e384527065f2f8946f5e86320d0117839a5e98ea2c0b55fb0048554e54": {
    token_id: "95a427e384527065f2f8946f5e86320d0117839a5e98ea2c0b55fb0048554e54",
    token_policy: "95a427e384527065f2f8946f5e86320d0117839a5e98ea2c0b55fb00",
    token_ascii: "DexHunter",
    is_verified: !0,
    ticker: "HUNT",
    decimals: 6
  },
  a3931691f5c4e65d01c429e473d0dd24c51afdb6daf88e632a6c1e516f7263666178746f6b656e: {
    token_id: "a3931691f5c4e65d01c429e473d0dd24c51afdb6daf88e632a6c1e516f7263666178746f6b656e",
    token_policy: "a3931691f5c4e65d01c429e473d0dd24c51afdb6daf88e632a6c1e51",
    token_ascii: "Orcfax Token",
    is_verified: !0,
    ticker: "FACT"
  },
  "279f842c33eed9054b9e3c70cd6a3b32298259c24b78b895cb41d91a54554e41": {
    token_id: "279f842c33eed9054b9e3c70cd6a3b32298259c24b78b895cb41d91a54554e41",
    token_policy: "279f842c33eed9054b9e3c70cd6a3b32298259c24b78b895cb41d91a",
    token_ascii: "Fortuna",
    is_verified: !0,
    ticker: "TUNA"
  },
  "501dd5d2fbab6af0a26b1421076ff3afc4d5a34d6b3f9694571116ea4b4f4e4441": {
    token_id: "501dd5d2fbab6af0a26b1421076ff3afc4d5a34d6b3f9694571116ea4b4f4e4441",
    token_policy: "501dd5d2fbab6af0a26b1421076ff3afc4d5a34d6b3f9694571116ea",
    token_ascii: "AdaKondaCoin",
    is_verified: !0,
    ticker: "KONDA"
  },
  "12274673b36fa1507084eae4b9f78d28bd67266396331f46528c397441445548": {
    token_id: "12274673b36fa1507084eae4b9f78d28bd67266396331f46528c397441445548",
    token_policy: "12274673b36fa1507084eae4b9f78d28bd67266396331f46528c3974",
    token_ascii: "$ADUH",
    is_verified: !0,
    ticker: "$ADUH"
  },
  "2d92af60ee429bce238d3fd9f2531b45457301d74dad1bcf3f9d1dca564e4d": {
    token_id: "2d92af60ee429bce238d3fd9f2531b45457301d74dad1bcf3f9d1dca564e4d",
    token_policy: "2d92af60ee429bce238d3fd9f2531b45457301d74dad1bcf3f9d1dca",
    token_ascii: "Venom",
    is_verified: !0,
    ticker: "VNM"
  },
  ffb1abe9fe93ee9f13874403a3d4f8addaa65fbf22d5d7f41c087d8e4d5554414e54: {
    token_id: "ffb1abe9fe93ee9f13874403a3d4f8addaa65fbf22d5d7f41c087d8e4d5554414e54",
    token_policy: "ffb1abe9fe93ee9f13874403a3d4f8addaa65fbf22d5d7f41c087d8e",
    token_ascii: "MUTANT",
    is_verified: !0,
    ticker: "MUTANT"
  },
  f0451f9d13eb8e7c9be861a675d00cc4e0e174f527757b772c4dff18434845: {
    token_id: "f0451f9d13eb8e7c9be861a675d00cc4e0e174f527757b772c4dff18434845",
    token_policy: "f0451f9d13eb8e7c9be861a675d00cc4e0e174f527757b772c4dff18",
    token_ascii: "CheCoin",
    is_verified: !0,
    ticker: "CHE"
  },
  b34b3ea80060ace9427bda98690a73d33840e27aaa8d6edb7f0c757a634e455441: {
    token_id: "b34b3ea80060ace9427bda98690a73d33840e27aaa8d6edb7f0c757a634e455441",
    token_policy: "b34b3ea80060ace9427bda98690a73d33840e27aaa8d6edb7f0c757a",
    token_ascii: "anetaBTC",
    is_verified: !0,
    ticker: "cNETA"
  },
  "0c92aabef5a8f91a36470d0762806c165c0d04aa992541e25d55486a424347": {
    token_id: "0c92aabef5a8f91a36470d0762806c165c0d04aa992541e25d55486a424347",
    token_policy: "0c92aabef5a8f91a36470d0762806c165c0d04aa992541e25d55486a",
    token_ascii: "Blockchaingames",
    is_verified: !0,
    ticker: "BCG"
  },
  "6a078f51d4a343c5f9022ebe2fa88975a18cbd58442cb1021a1b900c54524f4c4c": {
    token_id: "6a078f51d4a343c5f9022ebe2fa88975a18cbd58442cb1021a1b900c54524f4c4c",
    token_policy: "6a078f51d4a343c5f9022ebe2fa88975a18cbd58442cb1021a1b900c",
    token_ascii: "Troll Coin",
    is_verified: !0,
    ticker: "TROLL"
  },
  "52489ea87bbceaf6375cc22f74c19382a3d5da3f8b9b15d2537044b95052535052": {
    token_id: "52489ea87bbceaf6375cc22f74c19382a3d5da3f8b9b15d2537044b95052535052",
    token_policy: "52489ea87bbceaf6375cc22f74c19382a3d5da3f8b9b15d2537044b9",
    token_ascii: "PRSPR",
    is_verified: !0,
    ticker: "PRSPR"
  },
  bf524874448cbf52be3a26133b0a0edf5eb65c09ffed383b881ad3274353574150: {
    token_id: "bf524874448cbf52be3a26133b0a0edf5eb65c09ffed383b881ad3274353574150",
    token_policy: "bf524874448cbf52be3a26133b0a0edf5eb65c09ffed383b881ad327",
    token_ascii: "CSWAP",
    is_verified: !0,
    ticker: "CSWAP"
  },
  "4a2e215bced3fd8ccc3edec108347d9f8984ef82bac8c8903f02d1b04144444158": {
    token_id: "4a2e215bced3fd8ccc3edec108347d9f8984ef82bac8c8903f02d1b04144444158",
    token_policy: "4a2e215bced3fd8ccc3edec108347d9f8984ef82bac8c8903f02d1b0",
    token_ascii: "ADDAX",
    is_verified: !0,
    ticker: "ADDAX"
  },
  "3f2880d10da4c8567ffc1f705b4b526c331ed2e875c63c4b68aff5804252454144": {
    token_id: "3f2880d10da4c8567ffc1f705b4b526c331ed2e875c63c4b68aff5804252454144",
    token_policy: "3f2880d10da4c8567ffc1f705b4b526c331ed2e875c63c4b68aff580",
    token_ascii: "Bread",
    is_verified: !0,
    ticker: "Bread"
  },
  "43b07d4037f0d75ee10f9863097463fc02ff3c0b8b705ae61d9c75bf4d796e746820546f6b656e": {
    token_id: "43b07d4037f0d75ee10f9863097463fc02ff3c0b8b705ae61d9c75bf4d796e746820546f6b656e",
    token_policy: "43b07d4037f0d75ee10f9863097463fc02ff3c0b8b705ae61d9c75bf",
    token_ascii: "Mynth Token",
    is_verified: !0,
    ticker: "MNT"
  },
  "94cbb4fcbcaa2975779f273b263eb3b5f24a9951e446d6dc4c135864": {
    token_id: "94cbb4fcbcaa2975779f273b263eb3b5f24a9951e446d6dc4c135864",
    token_policy: "94cbb4fcbcaa2975779f273b263eb3b5f24a9951e446d6dc4c135864",
    token_ascii: "Revuto",
    is_verified: !0,
    ticker: "REVU"
  },
  "961f2cac0bb1967d74691af179350c1e1062c7298d1f7be1e4696e312444455250": {
    token_id: "961f2cac0bb1967d74691af179350c1e1062c7298d1f7be1e4696e312444455250",
    token_policy: "961f2cac0bb1967d74691af179350c1e1062c7298d1f7be1e4696e31",
    token_ascii: "Derp Utility Token",
    is_verified: !0,
    ticker: "DERP"
  },
  c4c00fbd8fa227442a5e7cdecde33b24588494d05a2c50fda8938c6d4b49445a: {
    token_id: "c4c00fbd8fa227442a5e7cdecde33b24588494d05a2c50fda8938c6d4b49445a",
    token_policy: "c4c00fbd8fa227442a5e7cdecde33b24588494d05a2c50fda8938c6d",
    token_ascii: "Kidz Coin",
    is_verified: !0,
    ticker: "KIDZ"
  },
  e3334680040528178a13026dee65a620be396d4a34b25a524c653af14c495a4f: {
    token_id: "e3334680040528178a13026dee65a620be396d4a34b25a524c653af14c495a4f",
    token_policy: "e3334680040528178a13026dee65a620be396d4a34b25a524c653af1",
    token_ascii: "Lizo Token",
    is_verified: !0,
    ticker: "LIZO"
  },
  "6787a47e9f73efe4002d763337140da27afa8eb9a39413d2c39d4286524144546f6b656e73": {
    token_id: "6787a47e9f73efe4002d763337140da27afa8eb9a39413d2c39d4286524144546f6b656e73",
    token_policy: "6787a47e9f73efe4002d763337140da27afa8eb9a39413d2c39d4286",
    token_ascii: "RADTokens",
    is_verified: !0,
    ticker: "RAD"
  },
  d3a034e403b98cbdb0adbc8a3144d7779330916e190d387815bb85c650555252: {
    token_id: "d3a034e403b98cbdb0adbc8a3144d7779330916e190d387815bb85c650555252",
    token_policy: "d3a034e403b98cbdb0adbc8a3144d7779330916e190d387815bb85c6",
    token_ascii: "CatKinson",
    is_verified: !0,
    ticker: "$PURR"
  },
  "533bb94a8850ee3ccbe483106489399112b74c905342cb1792a797a0494e4459": {
    token_id: "533bb94a8850ee3ccbe483106489399112b74c905342cb1792a797a0494e4459",
    token_policy: "533bb94a8850ee3ccbe483106489399112b74c905342cb1792a797a0",
    token_ascii: "Indigo DAO Token",
    is_verified: !0,
    ticker: "INDY"
  },
  "401f734390bb03578000c28b7c69d818fce14de3caed59c8aaec08ff47494e4b4f": {
    token_id: "401f734390bb03578000c28b7c69d818fce14de3caed59c8aaec08ff47494e4b4f",
    token_policy: "401f734390bb03578000c28b7c69d818fce14de3caed59c8aaec08ff",
    token_ascii: "GINKO",
    is_verified: !0,
    ticker: "GINKO"
  },
  "7bf18ff8bbc7cd4adbf4a31828fc3ada26fe40f52de27394ec36b03e4f544b2052756d": {
    token_id: "7bf18ff8bbc7cd4adbf4a31828fc3ada26fe40f52de27394ec36b03e4f544b2052756d",
    token_policy: "7bf18ff8bbc7cd4adbf4a31828fc3ada26fe40f52de27394ec36b03e",
    token_ascii: "OTK Rum Token",
    is_verified: !0,
    ticker: "RUM"
  },
  "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c457370657273": {
    token_id: "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c457370657273",
    token_policy: "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c",
    token_ascii: "Espers",
    is_verified: !0,
    ticker: "wESP"
  },
  "43a078846ae28140f5a5c2714ffcc689555d7e0efcfcaf79ce2910fa487964726147616d6573": {
    token_id: "43a078846ae28140f5a5c2714ffcc689555d7e0efcfcaf79ce2910fa487964726147616d6573",
    token_policy: "43a078846ae28140f5a5c2714ffcc689555d7e0efcfcaf79ce2910fa",
    token_ascii: "HydraGames",
    is_verified: !0,
    ticker: "HYDRGMS"
  },
  "376b46d7abe9a2a8d9d6dfa8f1979c41bc4251f02bbd7bc58acf3e704a6675656c": {
    token_id: "376b46d7abe9a2a8d9d6dfa8f1979c41bc4251f02bbd7bc58acf3e704a6675656c",
    token_policy: "376b46d7abe9a2a8d9d6dfa8f1979c41bc4251f02bbd7bc58acf3e70",
    token_ascii: "Jfuel",
    is_verified: !0,
    ticker: "Jfuel"
  },
  "9d093d73d273ff6456e85bcd9c524fa18fedb0f0274e41d7344a57b4444f4e4f54425559": {
    token_id: "9d093d73d273ff6456e85bcd9c524fa18fedb0f0274e41d7344a57b4444f4e4f54425559",
    token_policy: "9d093d73d273ff6456e85bcd9c524fa18fedb0f0274e41d7344a57b4",
    token_ascii: "DONOTBUY",
    is_verified: !0,
    ticker: "DNB"
  },
  ad1c1ed3a0bb6f83630ef052a31b71ba3287bf4bafa8370758f14d315349434b: {
    token_id: "ad1c1ed3a0bb6f83630ef052a31b71ba3287bf4bafa8370758f14d315349434b",
    token_policy: "ad1c1ed3a0bb6f83630ef052a31b71ba3287bf4bafa8370758f14d31",
    token_ascii: "SICK",
    is_verified: !0,
    ticker: "SICK"
  },
  a26022096c6a8052987dabbfa94849ab7886cf0bb7840044e017d5be4b756265436f696e: {
    token_id: "a26022096c6a8052987dabbfa94849ab7886cf0bb7840044e017d5be4b756265436f696e",
    token_policy: "a26022096c6a8052987dabbfa94849ab7886cf0bb7840044e017d5be",
    token_ascii: "KubeCoin",
    is_verified: !0,
    ticker: "KUBE"
  },
  c9281d64953f9531304e57e4ff15111f0c5445167c0b413f70fcd50c52554e45: {
    token_id: "c9281d64953f9531304e57e4ff15111f0c5445167c0b413f70fcd50c52554e45",
    token_policy: "c9281d64953f9531304e57e4ff15111f0c5445167c0b413f70fcd50c",
    token_ascii: "RUNE",
    is_verified: !0,
    ticker: "RUNE"
  },
  "92292852e3820cfbe99874b284fdf2befbddb38e070cf3512009a60a436f6c6f72506561726c": {
    token_id: "92292852e3820cfbe99874b284fdf2befbddb38e070cf3512009a60a436f6c6f72506561726c",
    token_policy: "92292852e3820cfbe99874b284fdf2befbddb38e070cf3512009a60a",
    token_ascii: "Color Pearl",
    is_verified: !0,
    ticker: "CP"
  },
  "41a806e6cc38741eb81cc68f6300ee37df0c10b6b99dcb251aa82c3b5a5230": {
    token_id: "41a806e6cc38741eb81cc68f6300ee37df0c10b6b99dcb251aa82c3b5a5230",
    token_policy: "41a806e6cc38741eb81cc68f6300ee37df0c10b6b99dcb251aa82c3b",
    token_ascii: "Zero",
    is_verified: !0,
    ticker: "ZRO"
  },
  "279c909f348e533da5808898f87f9a14bb2c3dfbbacccd631d927a3f534e454b": {
    token_id: "279c909f348e533da5808898f87f9a14bb2c3dfbbacccd631d927a3f534e454b",
    token_policy: "279c909f348e533da5808898f87f9a14bb2c3dfbbacccd631d927a3f",
    token_ascii: "Snek",
    is_verified: !0,
    ticker: "SNEK"
  },
  eb2fb0975dbd8d4b439eef8f252dbbf7dea998e58186b6a74b5431b353414c5a59: {
    token_id: "eb2fb0975dbd8d4b439eef8f252dbbf7dea998e58186b6a74b5431b353414c5a59",
    token_policy: "eb2fb0975dbd8d4b439eef8f252dbbf7dea998e58186b6a74b5431b3",
    token_ascii: "Salzy Token",
    is_verified: !0,
    ticker: "SALZY"
  },
  "65bdf33f8f7fd4debeb2ad659473749eb4eac177e06650bb75a8fe504d69746872546f6b656e": {
    token_id: "65bdf33f8f7fd4debeb2ad659473749eb4eac177e06650bb75a8fe504d69746872546f6b656e",
    token_policy: "65bdf33f8f7fd4debeb2ad659473749eb4eac177e06650bb75a8fe50",
    token_ascii: "Mithrandir Token",
    is_verified: !0,
    ticker: "MITHR"
  },
  "32bc130691066340caf48ef53d52c684a0e497ffc935d2fd6741efe0574f5a": {
    token_id: "32bc130691066340caf48ef53d52c684a0e497ffc935d2fd6741efe0574f5a",
    token_policy: "32bc130691066340caf48ef53d52c684a0e497ffc935d2fd6741efe0",
    token_ascii: "Wozdog",
    is_verified: !0,
    ticker: "WOZ"
  },
  e1ed70ad8423bc63ac1287f2329c9380528284894dd4cbe70a5c722d5341454c454d: {
    token_id: "e1ed70ad8423bc63ac1287f2329c9380528284894dd4cbe70a5c722d5341454c454d",
    token_policy: "e1ed70ad8423bc63ac1287f2329c9380528284894dd4cbe70a5c722d",
    token_ascii: "SAELEM",
    is_verified: !0,
    ticker: "SAELEM"
  },
  "9f452e23804df3040b352b478039357b506ad3b50d2ce0d7cbd5f806435456": {
    token_id: "9f452e23804df3040b352b478039357b506ad3b50d2ce0d7cbd5f806435456",
    token_policy: "9f452e23804df3040b352b478039357b506ad3b50d2ce0d7cbd5f806",
    token_ascii: "CTV Governance Token",
    is_verified: !0,
    ticker: "CTV"
  },
  "79906b9c8d2fbddeba9658387a2a1187f3edd8f546e5dc49225710a146524f47474945": {
    token_id: "79906b9c8d2fbddeba9658387a2a1187f3edd8f546e5dc49225710a146524f47474945",
    token_policy: "79906b9c8d2fbddeba9658387a2a1187f3edd8f546e5dc49225710a1",
    token_ascii: "Froggie Koin",
    is_verified: !0,
    ticker: "FROGGIE"
  },
  af2e27f580f7f08e93190a81f72462f153026d06450924726645891b44524950: {
    token_id: "af2e27f580f7f08e93190a81f72462f153026d06450924726645891b44524950",
    token_policy: "af2e27f580f7f08e93190a81f72462f153026d06450924726645891b",
    token_ascii: "DRIP",
    is_verified: !0,
    ticker: "DRIP"
  },
  "473e6a5a73108783abdd8b540eb0bca7265741d1f1e8fa55b0e8ef32646567656e": {
    token_id: "473e6a5a73108783abdd8b540eb0bca7265741d1f1e8fa55b0e8ef32646567656e",
    token_policy: "473e6a5a73108783abdd8b540eb0bca7265741d1f1e8fa55b0e8ef32",
    token_ascii: "🧠",
    is_verified: !0,
    ticker: "DEG"
  },
  "02a4e5d69c39dc69ca5673836545743f425563965af06fe002bdd79043455446": {
    token_id: "02a4e5d69c39dc69ca5673836545743f425563965af06fe002bdd79043455446",
    token_policy: "02a4e5d69c39dc69ca5673836545743f425563965af06fe002bdd790",
    token_ascii: "cETF",
    is_verified: !0,
    ticker: "CETF"
  },
  f66d78b4a3cb3d37afa0ec36461e51ecbde00f26c8f0a68f94b6988069555344: {
    token_id: "f66d78b4a3cb3d37afa0ec36461e51ecbde00f26c8f0a68f94b6988069555344",
    token_policy: "f66d78b4a3cb3d37afa0ec36461e51ecbde00f26c8f0a68f94b69880",
    token_ascii: "iUSD",
    is_verified: !0,
    ticker: "iUSD"
  },
  "6767df9b642eb1252ceb2d469a85b93889eae2790acd788ea31fa0834b495441": {
    token_id: "6767df9b642eb1252ceb2d469a85b93889eae2790acd788ea31fa0834b495441",
    token_policy: "6767df9b642eb1252ceb2d469a85b93889eae2790acd788ea31fa083",
    token_ascii: "KITA Coin",
    is_verified: !0,
    ticker: "KITA"
  },
  "3682715f97086e72ff37a7e6759a5ff0b44c98296afc2b407debe52b524f554e44": {
    token_id: "3682715f97086e72ff37a7e6759a5ff0b44c98296afc2b407debe52b524f554e44",
    token_policy: "3682715f97086e72ff37a7e6759a5ff0b44c98296afc2b407debe52b",
    token_ascii: "ROUNDTRIP",
    is_verified: !0,
    ticker: "ROUND"
  },
  "50009ca6291a2d1069bfb8d01dd2776401fe5d767f603b6cee55ab015241535441": {
    token_id: "50009ca6291a2d1069bfb8d01dd2776401fe5d767f603b6cee55ab015241535441",
    token_policy: "50009ca6291a2d1069bfb8d01dd2776401fe5d767f603b6cee55ab01",
    token_ascii: "RASTA",
    is_verified: !0,
    ticker: "RASTA"
  },
  "354a6c0acd846b195768ead31c92693ad26d82ba013e7df5d9777081514149": {
    token_id: "354a6c0acd846b195768ead31c92693ad26d82ba013e7df5d9777081514149",
    token_policy: "354a6c0acd846b195768ead31c92693ad26d82ba013e7df5d9777081",
    token_ascii: "QuantumAI",
    is_verified: !0,
    ticker: "QAI"
  },
  "20cd68533b47565f3c61efb39c30fdace9963bfa4c0060b613448e3c50524f584945": {
    token_id: "20cd68533b47565f3c61efb39c30fdace9963bfa4c0060b613448e3c50524f584945",
    token_policy: "20cd68533b47565f3c61efb39c30fdace9963bfa4c0060b613448e3c",
    token_ascii: "PROXIE",
    is_verified: !0,
    ticker: "PROXIE"
  },
  a00fdf4fb9ab6c8c2bd1533a2f14855edf12aed5ecbf96d4b5f5b9394334: {
    token_id: "a00fdf4fb9ab6c8c2bd1533a2f14855edf12aed5ecbf96d4b5f5b9394334",
    token_policy: "a00fdf4fb9ab6c8c2bd1533a2f14855edf12aed5ecbf96d4b5f5b939",
    token_ascii: "Cardano Crocs Club Coin",
    is_verified: !0,
    ticker: "C4"
  },
  a8a1dccea2e378081f2d500d98d022dd3c0bd77afd9dbc7b55a9d21b63544f5349: {
    token_id: "a8a1dccea2e378081f2d500d98d022dd3c0bd77afd9dbc7b55a9d21b63544f5349",
    token_policy: "a8a1dccea2e378081f2d500d98d022dd3c0bd77afd9dbc7b55a9d21b",
    token_ascii: "TOSI",
    is_verified: !0,
    ticker: "cTOSI"
  },
  ce5b9e0f8a88255b65f2e4d065c6e716e9fa9a8a86dfb86423dd1ac044494e47: {
    token_id: "ce5b9e0f8a88255b65f2e4d065c6e716e9fa9a8a86dfb86423dd1ac044494e47",
    token_policy: "ce5b9e0f8a88255b65f2e4d065c6e716e9fa9a8a86dfb86423dd1ac0",
    token_ascii: "DING",
    is_verified: !0,
    ticker: "DING"
  },
  "59515c449f1ec1d21a4b2d93013337d13b29d74c3a665a11d5b7fc6644534c5652": {
    token_id: "59515c449f1ec1d21a4b2d93013337d13b29d74c3a665a11d5b7fc6644534c5652",
    token_policy: "59515c449f1ec1d21a4b2d93013337d13b29d74c3a665a11d5b7fc66",
    token_ascii: "Digital Silver Token",
    is_verified: !0,
    ticker: "DSLVR"
  },
  "25c5de5f5b286073c593edfd77b48abc7a48e5a4f3d4cd9d428ff935455448": {
    token_id: "25c5de5f5b286073c593edfd77b48abc7a48e5a4f3d4cd9d428ff935455448",
    token_policy: "25c5de5f5b286073c593edfd77b48abc7a48e5a4f3d4cd9d428ff935",
    token_ascii: "ETH",
    is_verified: !0,
    ticker: "ETH"
  },
  d01794c4604f3c0e544c537bb1f4268c0e81f45880c00c09ebe4b4a74d595354: {
    token_id: "d01794c4604f3c0e544c537bb1f4268c0e81f45880c00c09ebe4b4a74d595354",
    token_policy: "d01794c4604f3c0e544c537bb1f4268c0e81f45880c00c09ebe4b4a7",
    token_ascii: "Mystery Token",
    is_verified: !0,
    ticker: "MYST"
  },
  "9b199c2d7d2f8fe66c8da8b843380c2228d3e92aee64a3ee81d9d50453757065725065736f": {
    token_id: "9b199c2d7d2f8fe66c8da8b843380c2228d3e92aee64a3ee81d9d50453757065725065736f",
    token_policy: "9b199c2d7d2f8fe66c8da8b843380c2228d3e92aee64a3ee81d9d504",
    token_ascii: "SuperPeso",
    is_verified: !0,
    ticker: "SuperPeso"
  },
  a56b1bfd69d317076c5c864d647851e2961594b21ec056f3c84914856473636e: {
    token_id: "a56b1bfd69d317076c5c864d647851e2961594b21ec056f3c84914856473636e",
    token_policy: "a56b1bfd69d317076c5c864d647851e2961594b21ec056f3c8491485",
    token_ascii: "Comic Coin",
    is_verified: !0,
    ticker: "CMC"
  },
  "7536b72f0d1f84c7935fc3b4471032ad4ca33b92974d0a3fe7e03e514d494e474f": {
    token_id: "7536b72f0d1f84c7935fc3b4471032ad4ca33b92974d0a3fe7e03e514d494e474f",
    token_policy: "7536b72f0d1f84c7935fc3b4471032ad4ca33b92974d0a3fe7e03e51",
    token_ascii: "MINGO",
    is_verified: !0,
    ticker: "MINGO"
  },
  cc8d1b026353022abbfcc2e1e71159f9e308d9c6e905ac1db24c7fb650617269627573: {
    token_id: "cc8d1b026353022abbfcc2e1e71159f9e308d9c6e905ac1db24c7fb650617269627573",
    token_policy: "cc8d1b026353022abbfcc2e1e71159f9e308d9c6e905ac1db24c7fb6",
    token_ascii: "Paribus",
    is_verified: !0,
    ticker: "PBX"
  },
  "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c46726f67436f696e": {
    token_id: "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c46726f67436f696e",
    token_policy: "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c",
    token_ascii: "FrogCoin",
    is_verified: !0,
    ticker: "wFROG"
  },
  "057e283baef26fe8879f0a5b56d55893507cee6933c85babcb8db216464441": {
    token_id: "057e283baef26fe8879f0a5b56d55893507cee6933c85babcb8db216464441",
    token_policy: "057e283baef26fe8879f0a5b56d55893507cee6933c85babcb8db216",
    token_ascii: "FDA",
    is_verified: !0,
    ticker: "FDA"
  },
  a0028f350aaabe0545fdcb56b039bfb08e4bb4d8c4d7c3c7d481c235484f534b59: {
    token_id: "a0028f350aaabe0545fdcb56b039bfb08e4bb4d8c4d7c3c7d481c235484f534b59",
    token_policy: "a0028f350aaabe0545fdcb56b039bfb08e4bb4d8c4d7c3c7d481c235",
    token_ascii: "HOSKY Token",
    is_verified: !0,
    ticker: "HOSKY"
  },
  "25c5de5f5b286073c593edfd77b48abc7a48e5a4f3d4cd9d428ff935425443": {
    token_id: "25c5de5f5b286073c593edfd77b48abc7a48e5a4f3d4cd9d428ff935425443",
    token_policy: "25c5de5f5b286073c593edfd77b48abc7a48e5a4f3d4cd9d428ff935",
    token_ascii: "BTC",
    is_verified: !0,
    ticker: "BTC"
  },
  "4a50a3c79cd9365b8eb10e257865f93f0e05d79004b409956fdcb3a85a414c474f": {
    token_id: "4a50a3c79cd9365b8eb10e257865f93f0e05d79004b409956fdcb3a85a414c474f",
    token_policy: "4a50a3c79cd9365b8eb10e257865f93f0e05d79004b409956fdcb3a8",
    token_ascii: "Zalgocoin",
    is_verified: !0,
    ticker: "ZALGO"
  },
  e9c28a71273f825b13f38244ccf1fea97c4025813610d01a7c5d681f436861726c7a20546f6b656e: {
    token_id: "e9c28a71273f825b13f38244ccf1fea97c4025813610d01a7c5d681f436861726c7a20546f6b656e",
    token_policy: "e9c28a71273f825b13f38244ccf1fea97c4025813610d01a7c5d681f",
    token_ascii: "Charlz Token",
    is_verified: !0,
    ticker: "CHRLZ"
  },
  a1ce0414d79b040f986f3bcd187a7563fd26662390dece6b12262b52464c45534820544f4b454e: {
    token_id: "a1ce0414d79b040f986f3bcd187a7563fd26662390dece6b12262b52464c45534820544f4b454e",
    token_policy: "a1ce0414d79b040f986f3bcd187a7563fd26662390dece6b12262b52",
    token_ascii: "FLESH TOKEN",
    is_verified: !0,
    ticker: "FLEsH"
  },
  e6f464202e7c89befd79fdd3905ca96c896772721485dff66fd6b2d24144414c4f54: {
    token_id: "e6f464202e7c89befd79fdd3905ca96c896772721485dff66fd6b2d24144414c4f54",
    token_policy: "e6f464202e7c89befd79fdd3905ca96c896772721485dff66fd6b2d2",
    token_ascii: "AdaLot",
    is_verified: !0,
    ticker: "ADALOT"
  },
  "6a659a86a0f35825bb9b0724ee70bc6a090e5910e1423a86a48cc955434150": {
    token_id: "6a659a86a0f35825bb9b0724ee70bc6a090e5910e1423a86a48cc955434150",
    token_policy: "6a659a86a0f35825bb9b0724ee70bc6a090e5910e1423a86a48cc955",
    token_ascii: "CAPITALISM",
    is_verified: !0,
    ticker: "CAP"
  },
  "2adf188218a66847024664f4f63939577627a56c090f679fe366c5ee535441424c45": {
    token_id: "2adf188218a66847024664f4f63939577627a56c090f679fe366c5ee535441424c45",
    token_policy: "2adf188218a66847024664f4f63939577627a56c090f679fe366c5ee",
    token_ascii: "Stablecoin",
    is_verified: !0,
    ticker: "STABLE"
  },
  f2fe9aafd2e5b3b00e2949a96d44a84d9f4d818d63945010a466a4ae4155444954: {
    token_id: "f2fe9aafd2e5b3b00e2949a96d44a84d9f4d818d63945010a466a4ae4155444954",
    token_policy: "f2fe9aafd2e5b3b00e2949a96d44a84d9f4d818d63945010a466a4ae",
    token_ascii: "Smart Contract Audit Token",
    is_verified: !0,
    ticker: "AUDIT"
  },
  e8e6b35d977a56ae5a221786eb0b2b348b8555e6e6afc6a54c25d2c54379636c72: {
    token_id: "e8e6b35d977a56ae5a221786eb0b2b348b8555e6e6afc6a54c25d2c54379636c72",
    token_policy: "e8e6b35d977a56ae5a221786eb0b2b348b8555e6e6afc6a54c25d2c5",
    token_ascii: "Cyclr",
    is_verified: !0,
    ticker: "Cyclr"
  },
  "86abe45be4d8fb2e8f28e8047d17d0ba5592f2a6c8c452fc88c2c14358524159": {
    token_id: "86abe45be4d8fb2e8f28e8047d17d0ba5592f2a6c8c452fc88c2c14358524159",
    token_policy: "86abe45be4d8fb2e8f28e8047d17d0ba5592f2a6c8c452fc88c2c143",
    token_ascii: "XRAY",
    is_verified: !0,
    ticker: "XRAY"
  },
  "5d16cc1a177b5d9ba9cfa9793b07e60f1fb70fea1f8aef064415d114494147": {
    token_id: "5d16cc1a177b5d9ba9cfa9793b07e60f1fb70fea1f8aef064415d114494147",
    token_policy: "5d16cc1a177b5d9ba9cfa9793b07e60f1fb70fea1f8aef064415d114",
    token_ascii: "IAGON",
    is_verified: !0,
    ticker: "IAG"
  },
  a1fb1a8f55298d54133e96c8edba68244ef14d9e27272bf9b9643e0a465844: {
    token_id: "a1fb1a8f55298d54133e96c8edba68244ef14d9e27272bf9b9643e0a465844",
    token_policy: "a1fb1a8f55298d54133e96c8edba68244ef14d9e27272bf9b9643e0a",
    token_ascii: "FXD",
    is_verified: !0,
    ticker: "FXD"
  },
  a8a1dccea2e378081f2d500d98d022dd3c0bd77afd9dbc7b55a9d21b63544f534920: {
    token_id: "a8a1dccea2e378081f2d500d98d022dd3c0bd77afd9dbc7b55a9d21b63544f534920",
    token_policy: "a8a1dccea2e378081f2d500d98d022dd3c0bd77afd9dbc7b55a9d21b",
    token_ascii: "TOSI",
    is_verified: !0,
    ticker: "cTOSI"
  },
  "6954264b15bc92d6d592febeac84f14645e1ed46ca5ebb9acdb5c15f5354524950": {
    token_id: "6954264b15bc92d6d592febeac84f14645e1ed46ca5ebb9acdb5c15f5354524950",
    token_policy: "6954264b15bc92d6d592febeac84f14645e1ed46ca5ebb9acdb5c15f",
    token_ascii: "StripperCoin",
    is_verified: !0,
    ticker: "STRIP"
  },
  b3bd74dd43f83815519e387bdffd1cb9be411df8f2774f48e0fd3669534e455045: {
    token_id: "b3bd74dd43f83815519e387bdffd1cb9be411df8f2774f48e0fd3669534e455045",
    token_policy: "b3bd74dd43f83815519e387bdffd1cb9be411df8f2774f48e0fd3669",
    token_ascii: "SNEPE",
    is_verified: !0,
    ticker: "SNEPE"
  },
  f43a62fdc3965df486de8a0d32fe800963589c41b38946602a0dc53541474958: {
    token_id: "f43a62fdc3965df486de8a0d32fe800963589c41b38946602a0dc53541474958",
    token_policy: "f43a62fdc3965df486de8a0d32fe800963589c41b38946602a0dc535",
    token_ascii: "SingularityNet AGIX Token",
    is_verified: !0,
    ticker: "AGIX"
  },
  "2274b1699f5398170e0497598de7877ebb370ba7b5d25a1d0b2fea075249534b": {
    token_id: "2274b1699f5398170e0497598de7877ebb370ba7b5d25a1d0b2fea075249534b",
    token_policy: "2274b1699f5398170e0497598de7877ebb370ba7b5d25a1d0b2fea07",
    token_ascii: "RISK",
    is_verified: !0,
    ticker: "RISK"
  },
  e14fe3ab348f9a6198359481472601f4557b9f86984f40a186a3b1e8434845525259: {
    token_id: "e14fe3ab348f9a6198359481472601f4557b9f86984f40a186a3b1e8434845525259",
    token_policy: "e14fe3ab348f9a6198359481472601f4557b9f86984f40a186a3b1e8",
    token_ascii: "CHERRY Token",
    is_verified: !0,
    ticker: "CHERRY"
  },
  "389224fd2601bc0d9fcf546430956d8d61b0dc911d6f41d57ccaf7e742414259": {
    token_id: "389224fd2601bc0d9fcf546430956d8d61b0dc911d6f41d57ccaf7e742414259",
    token_policy: "389224fd2601bc0d9fcf546430956d8d61b0dc911d6f41d57ccaf7e7",
    token_ascii: "BABY",
    is_verified: !0,
    ticker: "BABY"
  },
  "9e975c76508686eb2d57985dbaea7e3843767a31b4dcf4e99e5646834d41595a": {
    token_id: "9e975c76508686eb2d57985dbaea7e3843767a31b4dcf4e99e5646834d41595a",
    token_policy: "9e975c76508686eb2d57985dbaea7e3843767a31b4dcf4e99e564683",
    token_ascii: "MAYZ",
    is_verified: !0,
    ticker: "MAYZ",
    decimals: 6
  },
  "8d7cc34c1a44ef419cf1560cbb84e7720ca6c03ab99f8745ab61d19d50414e4441": {
    token_id: "8d7cc34c1a44ef419cf1560cbb84e7720ca6c03ab99f8745ab61d19d50414e4441",
    token_policy: "8d7cc34c1a44ef419cf1560cbb84e7720ca6c03ab99f8745ab61d19d",
    token_ascii: "PANDA Token",
    is_verified: !0,
    ticker: "PANDA"
  },
  "9c2a02b3a38380568749ff510a27d8884bd689dd6acbe2acfee4a509576f726c64": {
    token_id: "9c2a02b3a38380568749ff510a27d8884bd689dd6acbe2acfee4a509576f726c64",
    token_policy: "9c2a02b3a38380568749ff510a27d8884bd689dd6acbe2acfee4a509",
    token_ascii: "WorldCoin",
    is_verified: !0,
    ticker: "World"
  },
  faf9889f47c0b39177a7e07fe71ee5f5037beb01dcec3d4f2daae586456c657661746f72204c616273: {
    token_id: "faf9889f47c0b39177a7e07fe71ee5f5037beb01dcec3d4f2daae586456c657661746f72204c616273",
    token_policy: "faf9889f47c0b39177a7e07fe71ee5f5037beb01dcec3d4f2daae586",
    token_ascii: "ELV",
    is_verified: !0,
    ticker: "ELV"
  },
  e71a541df41dd14269bc63d40fb02bc91a3c3d344605948d173d88145748414c45: {
    token_id: "e71a541df41dd14269bc63d40fb02bc91a3c3d344605948d173d88145748414c45",
    token_policy: "e71a541df41dd14269bc63d40fb02bc91a3c3d344605948d173d8814",
    token_ascii: "WHALE",
    is_verified: !0,
    ticker: "WHALE"
  },
  "98986c9f88fbe01cb16af3fb85dcca5c876b5eff68aaa1d5e785b2756d6f6e6b6579": {
    token_id: "98986c9f88fbe01cb16af3fb85dcca5c876b5eff68aaa1d5e785b2756d6f6e6b6579",
    token_policy: "98986c9f88fbe01cb16af3fb85dcca5c876b5eff68aaa1d5e785b275",
    token_ascii: "monkey",
    is_verified: !0,
    ticker: "AMONKEY"
  },
  "9b426921a21f54600711da0be1a12b026703a9bd8eb9848d08c9d921434154534b59": {
    token_id: "9b426921a21f54600711da0be1a12b026703a9bd8eb9848d08c9d921434154534b59",
    token_policy: "9b426921a21f54600711da0be1a12b026703a9bd8eb9848d08c9d921",
    token_ascii: "Catsky Token",
    is_verified: !0,
    ticker: "CATSKY"
  },
  e043fd7b2076ea9e1b279d200b59e153bf6b299a72ce6e2c14aeb790424c554553: {
    token_id: "e043fd7b2076ea9e1b279d200b59e153bf6b299a72ce6e2c14aeb790424c554553",
    token_policy: "e043fd7b2076ea9e1b279d200b59e153bf6b299a72ce6e2c14aeb790",
    token_ascii: "BLUES",
    is_verified: !0,
    ticker: "BLUES"
  },
  "1e54cf3b5832978582ac3baade392fa09a52dbd588dae1a403c4d72c52554d41484b495441": {
    token_id: "1e54cf3b5832978582ac3baade392fa09a52dbd588dae1a403c4d72c52554d41484b495441",
    token_policy: "1e54cf3b5832978582ac3baade392fa09a52dbd588dae1a403c4d72c",
    token_ascii: "RUMAH KITA",
    is_verified: !0,
    ticker: "RK"
  },
  "2d420236ffaada336c21e3f4520b799f6e246d8618f2fc89a4907da64564756c6164646572546f6b656e": {
    token_id: "2d420236ffaada336c21e3f4520b799f6e246d8618f2fc89a4907da64564756c6164646572546f6b656e",
    token_policy: "2d420236ffaada336c21e3f4520b799f6e246d8618f2fc89a4907da6",
    token_ascii: "EduLadder Token",
    is_verified: !0,
    ticker: "ELADR"
  },
  "8f9c32977d2bacb87836b64f7811e99734c6368373958da20172afba4d5949454c44": {
    token_id: "8f9c32977d2bacb87836b64f7811e99734c6368373958da20172afba4d5949454c44",
    token_policy: "8f9c32977d2bacb87836b64f7811e99734c6368373958da20172afba",
    token_ascii: "MYIELD",
    is_verified: !0,
    ticker: "MYIELD"
  },
  b201928d6bdb21c2e39205a92e226653d6002b949eaaacde3d986c2f524f4e: {
    token_id: "b201928d6bdb21c2e39205a92e226653d6002b949eaaacde3d986c2f524f4e",
    token_policy: "b201928d6bdb21c2e39205a92e226653d6002b949eaaacde3d986c2f",
    token_ascii: "Ron",
    is_verified: !0,
    ticker: "RON"
  },
  "86b116d8cfd880445825208b4a355b7715b63763d6d8f3d37338d211657465726e616c": {
    token_id: "86b116d8cfd880445825208b4a355b7715b63763d6d8f3d37338d211657465726e616c",
    token_policy: "86b116d8cfd880445825208b4a355b7715b63763d6d8f3d37338d211",
    token_ascii: "Eternal",
    is_verified: !0,
    ticker: "ETERNAL"
  },
  c4c497a70541172b39be5d30c89e07a047b0a75b17adbf41927a5c9748545048: {
    token_id: "c4c497a70541172b39be5d30c89e07a047b0a75b17adbf41927a5c9748545048",
    token_policy: "c4c497a70541172b39be5d30c89e07a047b0a75b17adbf41927a5c97",
    token_ascii: "Hide the pain Harold Meme Token",
    is_verified: !0,
    ticker: "HTPH"
  },
  "78985eeb3babbfd4029864598a9a6064283543ba7551c3cc199ddf775344554d50": {
    token_id: "78985eeb3babbfd4029864598a9a6064283543ba7551c3cc199ddf775344554d50",
    token_policy: "78985eeb3babbfd4029864598a9a6064283543ba7551c3cc199ddf77",
    token_ascii: "DUMP",
    is_verified: !0,
    ticker: "DUMP"
  },
  "85d87212f6096732ac1cdbf604a12aa8cfd1fd0b66ab28fc77d3764c44494e4f": {
    token_id: "85d87212f6096732ac1cdbf604a12aa8cfd1fd0b66ab28fc77d3764c44494e4f",
    token_policy: "85d87212f6096732ac1cdbf604a12aa8cfd1fd0b66ab28fc77d3764c",
    token_ascii: "DINO",
    is_verified: !0,
    ticker: "DINO"
  },
  fbae99b8679369079a7f6f0da14a2cf1c2d6bfd3afdf3a96a64ab67a0014df1047454e5358: {
    token_id: "fbae99b8679369079a7f6f0da14a2cf1c2d6bfd3afdf3a96a64ab67a0014df1047454e5358",
    token_policy: "fbae99b8679369079a7f6f0da14a2cf1c2d6bfd3afdf3a96a64ab67a",
    token_ascii: "Genius X",
    is_verified: !0,
    ticker: "GENSX"
  },
  c50e06eb7d36ce67af2b15dd38228b59e39a5dae644166c84e3d2d1344554d42: {
    token_id: "c50e06eb7d36ce67af2b15dd38228b59e39a5dae644166c84e3d2d1344554d42",
    token_policy: "c50e06eb7d36ce67af2b15dd38228b59e39a5dae644166c84e3d2d13",
    token_ascii: "DUMB",
    is_verified: !0,
    ticker: "DUMB"
  },
  a2936e00439913f1ac105c29883c013322360247c409343028b831be4d564f5543484552: {
    token_id: "a2936e00439913f1ac105c29883c013322360247c409343028b831be4d564f5543484552",
    token_policy: "a2936e00439913f1ac105c29883c013322360247c409343028b831be",
    token_ascii: "MILK Voucher",
    is_verified: !0,
    ticker: "MVOUCHER"
  },
  dbc31b04d90b37332813cb4cee3e8f79994643d899a5366797e745ee465544: {
    token_id: "dbc31b04d90b37332813cb4cee3e8f79994643d899a5366797e745ee465544",
    token_policy: "dbc31b04d90b37332813cb4cee3e8f79994643d899a5366797e745ee",
    token_ascii: "FudCoin",
    is_verified: !0,
    ticker: "FUD"
  },
  "804f5544c1962a40546827cab750a88404dc7108c0f588b72964754f56594649": {
    token_id: "804f5544c1962a40546827cab750a88404dc7108c0f588b72964754f56594649",
    token_policy: "804f5544c1962a40546827cab750a88404dc7108c0f588b72964754f",
    token_ascii: "VYFI",
    is_verified: !0,
    ticker: "VYFI"
  },
  "1111170eb2f1fc2eaf1ea6503c0160eda20de2a84418f988720a7c8e4b525950544f": {
    token_id: "1111170eb2f1fc2eaf1ea6503c0160eda20de2a84418f988720a7c8e4b525950544f",
    token_policy: "1111170eb2f1fc2eaf1ea6503c0160eda20de2a84418f988720a7c8e",
    token_ascii: "Krypto Coin",
    is_verified: !0,
    ticker: "KC"
  },
  bf9354cba4ee83c5de05c72830c6430967a26a1656b06293541d23e154414e47: {
    token_id: "bf9354cba4ee83c5de05c72830c6430967a26a1656b06293541d23e154414e47",
    token_policy: "bf9354cba4ee83c5de05c72830c6430967a26a1656b06293541d23e1",
    token_ascii: "Tangent Protocol",
    is_verified: !0,
    ticker: "TANG"
  },
  da247e71f71b0195c8188bf43827f34c9357cc388fceed596d100d95424f54: {
    token_id: "da247e71f71b0195c8188bf43827f34c9357cc388fceed596d100d95424f54",
    token_policy: "da247e71f71b0195c8188bf43827f34c9357cc388fceed596d100d95",
    token_ascii: "BOT",
    is_verified: !0,
    ticker: "BOT"
  },
  ea2d23f1fa631b414252824c153f2d6ba833506477a929770a4dd9c24d414442554c: {
    token_id: "ea2d23f1fa631b414252824c153f2d6ba833506477a929770a4dd9c24d414442554c",
    token_policy: "ea2d23f1fa631b414252824c153f2d6ba833506477a929770a4dd9c2",
    token_ascii: "MAdbuLL token",
    is_verified: !0,
    ticker: "MADBL"
  },
  "0171c997b8853fde686763d93b36ab8e04ce947bb6aa09a9ee5c4401544f4b454e": {
    token_id: "0171c997b8853fde686763d93b36ab8e04ce947bb6aa09a9ee5c4401544f4b454e",
    token_policy: "0171c997b8853fde686763d93b36ab8e04ce947bb6aa09a9ee5c4401",
    token_ascii: "TOKEN",
    is_verified: !0,
    ticker: "TOKEN"
  },
  f01ec1cb021922a491ea300fb4791dbaca720372b2a3142579c52e7d4b616e69: {
    token_id: "f01ec1cb021922a491ea300fb4791dbaca720372b2a3142579c52e7d4b616e69",
    token_policy: "f01ec1cb021922a491ea300fb4791dbaca720372b2a3142579c52e7d",
    token_ascii: "Kani Token",
    is_verified: !0,
    ticker: "Kani"
  },
  "7192cee89b2cd731152e60de5fd849f3930c24ac97f6daca09b54cf35065616365": {
    token_id: "7192cee89b2cd731152e60de5fd849f3930c24ac97f6daca09b54cf35065616365",
    token_policy: "7192cee89b2cd731152e60de5fd849f3930c24ac97f6daca09b54cf3",
    token_ascii: "PeaceCoin",
    is_verified: !0,
    ticker: "Peace"
  },
  b38d94e35b3e638dce7e5e0b0aeebcbe06987a118b46d3d4c042c8c26861726d6c657373636f696e: {
    token_id: "b38d94e35b3e638dce7e5e0b0aeebcbe06987a118b46d3d4c042c8c26861726d6c657373636f696e",
    token_policy: "b38d94e35b3e638dce7e5e0b0aeebcbe06987a118b46d3d4c042c8c2",
    token_ascii: "harmlesscoin",
    is_verified: !0,
    ticker: "HARM"
  },
  ddbca1e3ee9849c439e13c2cc3daebea6ad17a04df11bc0aad3b76ae534848: {
    token_id: "ddbca1e3ee9849c439e13c2cc3daebea6ad17a04df11bc0aad3b76ae534848",
    token_policy: "ddbca1e3ee9849c439e13c2cc3daebea6ad17a04df11bc0aad3b76ae",
    token_ascii: "SHH",
    is_verified: !0,
    ticker: "SHH"
  },
  "94cbb4fcbcaa2975779f273b263eb3b5f24a9951e446d6dc4c13586452455655": {
    token_id: "94cbb4fcbcaa2975779f273b263eb3b5f24a9951e446d6dc4c13586452455655",
    token_policy: "94cbb4fcbcaa2975779f273b263eb3b5f24a9951e446d6dc4c135864",
    token_ascii: "Revuto",
    is_verified: !0,
    ticker: "REVU"
  },
  "43a078846ae28140f5a5c2714ffcc689555d7e0efcfcaf79ce2910fa4879647261": {
    token_id: "43a078846ae28140f5a5c2714ffcc689555d7e0efcfcaf79ce2910fa4879647261",
    token_policy: "43a078846ae28140f5a5c2714ffcc689555d7e0efcfcaf79ce2910fa",
    token_ascii: "HydraGames",
    is_verified: !0,
    ticker: "HYDRA"
  },
  "92292852e3820cfbe99874b284fdf2befbddb38e070cf3512009a60a426c61636b506561726c": {
    token_id: "92292852e3820cfbe99874b284fdf2befbddb38e070cf3512009a60a426c61636b506561726c",
    token_policy: "92292852e3820cfbe99874b284fdf2befbddb38e070cf3512009a60a",
    token_ascii: "Black Pearl",
    is_verified: !0,
    ticker: "BP"
  },
  "4632693c8a8ab3e325391bf319d69c24c54b823d70a85d870197fd3853414d55": {
    token_id: "4632693c8a8ab3e325391bf319d69c24c54b823d70a85d870197fd3853414d55",
    token_policy: "4632693c8a8ab3e325391bf319d69c24c54b823d70a85d870197fd38",
    token_ascii: "Samurai Token",
    is_verified: !0,
    ticker: "SAMU"
  },
  "462d81b809c4cbc9039a536a6139393d640e3f54c563c0404ef92a5f57415249": {
    token_id: "462d81b809c4cbc9039a536a6139393d640e3f54c563c0404ef92a5f57415249",
    token_policy: "462d81b809c4cbc9039a536a6139393d640e3f54c563c0404ef92a5f",
    token_ascii: "WARI",
    is_verified: !0,
    ticker: "WARI"
  },
  "50861cf745ea40fb79024380fa3b642152a47cb3acae2778a517f16357494c44": {
    token_id: "50861cf745ea40fb79024380fa3b642152a47cb3acae2778a517f16357494c44",
    token_policy: "50861cf745ea40fb79024380fa3b642152a47cb3acae2778a517f163",
    token_ascii: "WILD",
    is_verified: !0,
    ticker: "WILD"
  },
  "5e607fcf4933ae7a713a4d190ace86832c67e610eab8c27f71ae746a456e64": {
    token_id: "5e607fcf4933ae7a713a4d190ace86832c67e610eab8c27f71ae746a456e64",
    token_policy: "5e607fcf4933ae7a713a4d190ace86832c67e610eab8c27f71ae746a",
    token_ascii: "End",
    is_verified: !0,
    ticker: "END"
  },
  "25c5de5f5b286073c593edfd77b48abc7a48e5a4f3d4cd9d428ff93557414e": {
    token_id: "25c5de5f5b286073c593edfd77b48abc7a48e5a4f3d4cd9d428ff93557414e",
    token_policy: "25c5de5f5b286073c593edfd77b48abc7a48e5a4f3d4cd9d428ff935",
    token_ascii: "WAN",
    is_verified: !0,
    ticker: "WAN"
  },
  c30190b33eff1af6566201bed3400676d8a8e61ebb3180c14e90734e4d494c41445943: {
    token_id: "c30190b33eff1af6566201bed3400676d8a8e61ebb3180c14e90734e4d494c41445943",
    token_policy: "c30190b33eff1af6566201bed3400676d8a8e61ebb3180c14e90734e",
    token_ascii: "Milady Cardano",
    is_verified: !0,
    ticker: "LADYC"
  },
  dc280dbb5381ef28afbab4ca31751f13c29562d376998e907ff1af32474e5547: {
    token_id: "dc280dbb5381ef28afbab4ca31751f13c29562d376998e907ff1af32474e5547",
    token_policy: "dc280dbb5381ef28afbab4ca31751f13c29562d376998e907ff1af32",
    token_ascii: "Gold Nuggets",
    is_verified: !0,
    ticker: "GNUG"
  },
  c5f87616092bc2595960b3f87c8760703cc5afb87b3a025d9ae6f70470414441: {
    token_id: "c5f87616092bc2595960b3f87c8760703cc5afb87b3a025d9ae6f70470414441",
    token_policy: "c5f87616092bc2595960b3f87c8760703cc5afb87b3a025d9ae6f704",
    token_ascii: "pADA",
    is_verified: !0,
    ticker: "pADA"
  },
  b1a80ea5d4b5c9f8d550fb9fa9fe53433903f420a449c8977b3470fa4245414d: {
    token_id: "b1a80ea5d4b5c9f8d550fb9fa9fe53433903f420a449c8977b3470fa4245414d",
    token_policy: "b1a80ea5d4b5c9f8d550fb9fa9fe53433903f420a449c8977b3470fa",
    token_ascii: "Cardano Beam",
    is_verified: !0,
    ticker: "BEAM"
  },
  "6f46e1304b16d884c85c62fb0eef35028facdc41aaa0fd319a152ed64d434f53": {
    token_id: "6f46e1304b16d884c85c62fb0eef35028facdc41aaa0fd319a152ed64d434f53",
    token_policy: "6f46e1304b16d884c85c62fb0eef35028facdc41aaa0fd319a152ed6",
    token_ascii: "MCOS",
    is_verified: !0,
    ticker: "MCOS"
  },
  "25f0fc240e91bd95dcdaebd2ba7713fc5168ac77234a3d79449fc20c534f4349455459": {
    token_id: "25f0fc240e91bd95dcdaebd2ba7713fc5168ac77234a3d79449fc20c534f4349455459",
    token_policy: "25f0fc240e91bd95dcdaebd2ba7713fc5168ac77234a3d79449fc20c",
    token_ascii: "SOC",
    is_verified: !0,
    ticker: "SOC"
  },
  b4273f1d8d0021d188784c3d72dc514f602b7ab8cfb87e3134550c42446f6765414441: {
    token_id: "b4273f1d8d0021d188784c3d72dc514f602b7ab8cfb87e3134550c42446f6765414441",
    token_policy: "b4273f1d8d0021d188784c3d72dc514f602b7ab8cfb87e3134550c42",
    token_ascii: "DogeADA",
    is_verified: !0,
    ticker: "DGADA"
  },
  "8cfd6893f5f6c1cc954cec1a0a1460841b74da6e7803820dde62bb78524a56": {
    token_id: "8cfd6893f5f6c1cc954cec1a0a1460841b74da6e7803820dde62bb78524a56",
    token_policy: "8cfd6893f5f6c1cc954cec1a0a1460841b74da6e7803820dde62bb78",
    token_ascii: "Rejuve Token",
    is_verified: !0,
    ticker: "RJV"
  },
  a2944573e99d2ed3055b808eaa264f0bf119e01fc6b18863067c63e44d454c44: {
    token_id: "a2944573e99d2ed3055b808eaa264f0bf119e01fc6b18863067c63e44d454c44",
    token_policy: "a2944573e99d2ed3055b808eaa264f0bf119e01fc6b18863067c63e4",
    token_ascii: "MELD",
    is_verified: !0,
    ticker: "MELD"
  },
  "682fe60c9918842b3323c43b5144bc3d52a23bd2fb81345560d73f634e45574d": {
    token_id: "682fe60c9918842b3323c43b5144bc3d52a23bd2fb81345560d73f634e45574d",
    token_policy: "682fe60c9918842b3323c43b5144bc3d52a23bd2fb81345560d73f63",
    token_ascii: "NEWM",
    is_verified: !0,
    ticker: "NEWM"
  },
  "0fd9819a9d7fb414880883f43a42d33458f12bc5f9841cec6457dc155669527553": {
    token_id: "0fd9819a9d7fb414880883f43a42d33458f12bc5f9841cec6457dc155669527553",
    token_policy: "0fd9819a9d7fb414880883f43a42d33458f12bc5f9841cec6457dc15",
    token_ascii: "Virus",
    is_verified: !0,
    ticker: "virus"
  },
  "09f2d4e4a5c3662f4c1e6a7d9600e9605279dbdcedb22d4507cb6e75535046": {
    token_id: "09f2d4e4a5c3662f4c1e6a7d9600e9605279dbdcedb22d4507cb6e75535046",
    token_policy: "09f2d4e4a5c3662f4c1e6a7d9600e9605279dbdcedb22d4507cb6e75",
    token_ascii: "Spectrum",
    is_verified: !0,
    ticker: "SPF"
  },
  "29d222ce763455e3d7a09a665ce554f00ac89d2e99a1a83d267170c64d494e": {
    token_id: "29d222ce763455e3d7a09a665ce554f00ac89d2e99a1a83d267170c64d494e",
    token_policy: "29d222ce763455e3d7a09a665ce554f00ac89d2e99a1a83d267170c6",
    token_ascii: "Minswap",
    is_verified: !0,
    ticker: "MIN"
  },
  c0ee29a85b13209423b10447d3c2e6a50641a15c57770e27cb9d507357696e67526964657273: {
    token_id: "c0ee29a85b13209423b10447d3c2e6a50641a15c57770e27cb9d507357696e67526964657273",
    token_policy: "c0ee29a85b13209423b10447d3c2e6a50641a15c57770e27cb9d5073",
    token_ascii: "WingRiders Governance Token",
    is_verified: !0,
    ticker: "WRT"
  },
  "5ec2e9813fa385d9333d18186d8257d1b3ebea97bdec2dad74026d8d50554743484950": {
    token_id: "5ec2e9813fa385d9333d18186d8257d1b3ebea97bdec2dad74026d8d50554743484950",
    token_policy: "5ec2e9813fa385d9333d18186d8257d1b3ebea97bdec2dad74026d8d",
    token_ascii: "Space Pugs Poker Chip",
    is_verified: !0,
    ticker: "PUGCHIP"
  },
  "9f144f7c7c9e656f905c09442e08376dbb6ee0ef80dd8afe0a4fc07347726f6f7065657a546f6b656e": {
    token_id: "9f144f7c7c9e656f905c09442e08376dbb6ee0ef80dd8afe0a4fc07347726f6f7065657a546f6b656e",
    token_policy: "9f144f7c7c9e656f905c09442e08376dbb6ee0ef80dd8afe0a4fc073",
    token_ascii: "Groopeez Token",
    is_verified: !0,
    ticker: "NfA"
  },
  a5039068cb2b3ebcf874c0a4b012f19409befcf99e38c34c080af9d552686f6469756d436f696e: {
    token_id: "a5039068cb2b3ebcf874c0a4b012f19409befcf99e38c34c080af9d552686f6469756d436f696e",
    token_policy: "a5039068cb2b3ebcf874c0a4b012f19409befcf99e38c34c080af9d5",
    token_ascii: "Rhodium Coin",
    is_verified: !0,
    ticker: "RHOD"
  },
  efa0e694d5915f52b00a0d01135efdb85a0bdde7009bbcf68ea12a3d5456: {
    token_id: "efa0e694d5915f52b00a0d01135efdb85a0bdde7009bbcf68ea12a3d5456",
    token_policy: "efa0e694d5915f52b00a0d01135efdb85a0bdde7009bbcf68ea12a3d",
    token_ascii: "TV",
    is_verified: !0,
    ticker: "TV"
  },
  "24a87872afa67f8860b7f6e910a63ddaffe39ed3a8affb04981eeaa9434f544f": {
    token_id: "24a87872afa67f8860b7f6e910a63ddaffe39ed3a8affb04981eeaa9434f544f",
    token_policy: "24a87872afa67f8860b7f6e910a63ddaffe39ed3a8affb04981eeaa9",
    token_ascii: "COTO",
    is_verified: !0,
    ticker: "COTO"
  },
  f66d78b4a3cb3d37afa0ec36461e51ecbde00f26c8f0a68f94b6988069425443: {
    token_id: "f66d78b4a3cb3d37afa0ec36461e51ecbde00f26c8f0a68f94b6988069425443",
    token_policy: "f66d78b4a3cb3d37afa0ec36461e51ecbde00f26c8f0a68f94b69880",
    token_ascii: "iBTC",
    is_verified: !0,
    ticker: "iBTC"
  },
  "160a880d9fc45380737cb7e57ff859763230aab28b3ef6a84007bfcc4d495241": {
    token_id: "160a880d9fc45380737cb7e57ff859763230aab28b3ef6a84007bfcc4d495241",
    token_policy: "160a880d9fc45380737cb7e57ff859763230aab28b3ef6a84007bfcc",
    token_ascii: "MIRA - Chains of War",
    is_verified: !0,
    ticker: "MIRA"
  },
  "133fac9e153194428eb0919be39837b42b9e977fc7298f3ff1b76ef95055444759": {
    token_id: "133fac9e153194428eb0919be39837b42b9e977fc7298f3ff1b76ef95055444759",
    token_policy: "133fac9e153194428eb0919be39837b42b9e977fc7298f3ff1b76ef9",
    token_ascii: "$PUDGY Token",
    is_verified: !0,
    ticker: "PUDGY"
  },
  "4ffaa4ef3217df37c4995bb96066af4cb68dfcc66b9f2a10e0c333b95779726d73746f6e65": {
    token_id: "4ffaa4ef3217df37c4995bb96066af4cb68dfcc66b9f2a10e0c333b95779726d73746f6e65",
    token_policy: "4ffaa4ef3217df37c4995bb96066af4cb68dfcc66b9f2a10e0c333b9",
    token_ascii: "Wyrmstone",
    is_verified: !0,
    ticker: "WYRM"
  },
  "4fde92c2f6dbcfa2879b44f7453872b31394cfb2f70f1d4c411169ac427562626c65": {
    token_id: "4fde92c2f6dbcfa2879b44f7453872b31394cfb2f70f1d4c411169ac427562626c65",
    token_policy: "4fde92c2f6dbcfa2879b44f7453872b31394cfb2f70f1d4c411169ac",
    token_ascii: "Bubble",
    is_verified: !0,
    ticker: "BUBBLE"
  },
  "5b01968867e13432afaa2f814e1d15e332d6cd0aa77e350972b0967d4144414f476f7665726e616e6365546f6b656e": {
    token_id: "5b01968867e13432afaa2f814e1d15e332d6cd0aa77e350972b0967d4144414f476f7665726e616e6365546f6b656e",
    token_policy: "5b01968867e13432afaa2f814e1d15e332d6cd0aa77e350972b0967d",
    token_ascii: "ADAO Governance Token",
    is_verified: !0,
    ticker: "ADAO"
  },
  "1d7f33bd23d85e1a25d87d86fac4f199c3197a2f7afeb662a0f34e1e776f726c646d6f62696c65746f6b656e": {
    token_id: "1d7f33bd23d85e1a25d87d86fac4f199c3197a2f7afeb662a0f34e1e776f726c646d6f62696c65746f6b656e",
    token_policy: "1d7f33bd23d85e1a25d87d86fac4f199c3197a2f7afeb662a0f34e1e",
    token_ascii: "World Mobile Token",
    is_verified: !0,
    ticker: "WMT"
  },
  "95b1962fbb6c42c1a16a3ac60459806e7ee7dba4f845e4498082524f4e474d49": {
    token_id: "95b1962fbb6c42c1a16a3ac60459806e7ee7dba4f845e4498082524f4e474d49",
    token_policy: "95b1962fbb6c42c1a16a3ac60459806e7ee7dba4f845e4498082524f",
    token_ascii: "NGMI",
    is_verified: !0,
    ticker: "NGMI"
  },
  "884892bcdc360bcef87d6b3f806e7f9cd5ac30d999d49970e7a903ae5041564941": {
    token_id: "884892bcdc360bcef87d6b3f806e7f9cd5ac30d999d49970e7a903ae5041564941",
    token_policy: "884892bcdc360bcef87d6b3f806e7f9cd5ac30d999d49970e7a903ae",
    token_ascii: "PAVIA Token",
    is_verified: !0,
    ticker: "PAVIA"
  },
  "7192cee89b2cd731152e60de5fd849f3930c24ac97f6daca09b54cf34c6f7665": {
    token_id: "7192cee89b2cd731152e60de5fd849f3930c24ac97f6daca09b54cf34c6f7665",
    token_policy: "7192cee89b2cd731152e60de5fd849f3930c24ac97f6daca09b54cf3",
    token_ascii: "LoveCoin",
    is_verified: !0,
    ticker: "Love"
  },
  "815418a1b078a259e678ecccc9d7eac7648d10b88f6f75ce2db8a25a4672616374696f6e2045737461746520546f6b656e": {
    token_id: "815418a1b078a259e678ecccc9d7eac7648d10b88f6f75ce2db8a25a4672616374696f6e2045737461746520546f6b656e",
    token_policy: "815418a1b078a259e678ecccc9d7eac7648d10b88f6f75ce2db8a25a",
    token_ascii: "Fraction Estate Token",
    is_verified: !0,
    ticker: "FET"
  },
  "9abf0afd2f236a19f2842d502d0450cbcd9c79f123a9708f96fd9b96454e4353": {
    token_id: "9abf0afd2f236a19f2842d502d0450cbcd9c79f123a9708f96fd9b96454e4353",
    token_policy: "9abf0afd2f236a19f2842d502d0450cbcd9c79f123a9708f96fd9b96",
    token_ascii: "ENCOINS utility token",
    is_verified: !0,
    ticker: "ENCS"
  },
  cfbc6b8519f252b1f1694cdbb9df9f339b343bdd0f2079d84e4afdd941504543415348: {
    token_id: "cfbc6b8519f252b1f1694cdbb9df9f339b343bdd0f2079d84e4afdd941504543415348",
    token_policy: "cfbc6b8519f252b1f1694cdbb9df9f339b343bdd0f2079d84e4afdd9",
    token_ascii: "APECASH",
    is_verified: !0,
    ticker: "APECASH"
  },
  "23ac1afe924ebbc002cbc7afdf22f09a9ea8fb8bddd3b20398be71c2534841524b": {
    token_id: "23ac1afe924ebbc002cbc7afdf22f09a9ea8fb8bddd3b20398be71c2534841524b",
    token_policy: "23ac1afe924ebbc002cbc7afdf22f09a9ea8fb8bddd3b20398be71c2",
    token_ascii: "SHARK",
    is_verified: !0,
    ticker: "SHARK"
  },
  "25c5de5f5b286073c593edfd77b48abc7a48e5a4f3d4cd9d428ff93555534454": {
    token_id: "25c5de5f5b286073c593edfd77b48abc7a48e5a4f3d4cd9d428ff93555534454",
    token_policy: "25c5de5f5b286073c593edfd77b48abc7a48e5a4f3d4cd9d428ff935",
    token_ascii: "USDT",
    is_verified: !0,
    ticker: "USDT"
  },
  "0c3b14ddb319c5a50bfd93e69d0706d1527e2b2169744665a1c534d0635049474759": {
    token_id: "0c3b14ddb319c5a50bfd93e69d0706d1527e2b2169744665a1c534d0635049474759",
    token_policy: "0c3b14ddb319c5a50bfd93e69d0706d1527e2b2169744665a1c534d0",
    token_ascii: "cPiggy Bank Token",
    is_verified: !0,
    ticker: "cPIGGY"
  },
  "88691a70bb0fe49cf9124b4f78553c36c09fa6264844e2b2941191734575736b6f": {
    token_id: "88691a70bb0fe49cf9124b4f78553c36c09fa6264844e2b2941191734575736b6f",
    token_policy: "88691a70bb0fe49cf9124b4f78553c36c09fa6264844e2b294119173",
    token_ascii: "Eusko",
    is_verified: !0,
    ticker: "EUS"
  },
  cdaaee586376139ee8c3cc4061623968810d177ca5c300afb890b48a43415354: {
    token_id: "cdaaee586376139ee8c3cc4061623968810d177ca5c300afb890b48a43415354",
    token_policy: "cdaaee586376139ee8c3cc4061623968810d177ca5c300afb890b48a",
    token_ascii: "Carda Station Token",
    is_verified: !0,
    ticker: "$CAST"
  },
  "8654e8b350e298c80d2451beb5ed80fc9eee9f38ce6b039fb8706bc34c4f4253544552": {
    token_id: "8654e8b350e298c80d2451beb5ed80fc9eee9f38ce6b039fb8706bc34c4f4253544552",
    token_policy: "8654e8b350e298c80d2451beb5ed80fc9eee9f38ce6b039fb8706bc3",
    token_ascii: "LOBSTER",
    is_verified: !0,
    ticker: "$LOBSTER"
  },
  "521ec1ae6f87ec944a4b32890d62cd4a243d612f80fe26db999628f05757": {
    token_id: "521ec1ae6f87ec944a4b32890d62cd4a243d612f80fe26db999628f05757",
    token_policy: "521ec1ae6f87ec944a4b32890d62cd4a243d612f80fe26db999628f0",
    token_ascii: "Wild Warriors Token",
    is_verified: !0,
    ticker: "WW"
  },
  "2c85a478d53f0e484b852c357e56057dfd8e80a6b72ecb4daffe42e544444f53": {
    token_id: "2c85a478d53f0e484b852c357e56057dfd8e80a6b72ecb4daffe42e544444f53",
    token_policy: "2c85a478d53f0e484b852c357e56057dfd8e80a6b72ecb4daffe42e5",
    token_ascii: "The Official DDoS Coin",
    is_verified: !0,
    ticker: "DDOS"
  },
  df1d850c46d6c9d12cbf6181c35db9225a91b77c8a646b7f636f8ae40014df104e494e4a415a: {
    token_id: "df1d850c46d6c9d12cbf6181c35db9225a91b77c8a646b7f636f8ae40014df104e494e4a415a",
    token_policy: "df1d850c46d6c9d12cbf6181c35db9225a91b77c8a646b7f636f8ae4",
    token_ascii: "Danketsu Token",
    is_verified: !0,
    ticker: "NINJAZ"
  },
  "25c5de5f5b286073c593edfd77b48abc7a48e5a4f3d4cd9d428ff93555534443": {
    token_id: "25c5de5f5b286073c593edfd77b48abc7a48e5a4f3d4cd9d428ff93555534443",
    token_policy: "25c5de5f5b286073c593edfd77b48abc7a48e5a4f3d4cd9d428ff935",
    token_ascii: "USDC",
    is_verified: !0,
    ticker: "USDC"
  },
  ad1c1ed3a0bb6f83630ef052a31b71ba3287bf4bafa8370758f14d315349434b5349434b: {
    token_id: "ad1c1ed3a0bb6f83630ef052a31b71ba3287bf4bafa8370758f14d315349434b5349434b",
    token_policy: "ad1c1ed3a0bb6f83630ef052a31b71ba3287bf4bafa8370758f14d31",
    token_ascii: "SICK",
    is_verified: !0,
    ticker: "SICK"
  },
  "6ded36273214629f9ff35e9f9c7b8945d937a80a3796ddc4a646a50e485943": {
    token_id: "6ded36273214629f9ff35e9f9c7b8945d937a80a3796ddc4a646a50e485943",
    token_policy: "6ded36273214629f9ff35e9f9c7b8945d937a80a3796ddc4a646a50e",
    token_ascii: "HYC",
    is_verified: !0,
    ticker: "HYC"
  },
  "772791eb3f4b92874a49d487375a90db631988291c1a643b817668ca4d616420446f6720546f6b656e": {
    token_id: "772791eb3f4b92874a49d487375a90db631988291c1a643b817668ca4d616420446f6720546f6b656e",
    token_policy: "772791eb3f4b92874a49d487375a90db631988291c1a643b817668ca",
    token_ascii: "Mad Dog Token",
    is_verified: !0,
    ticker: "MD"
  },
  "8db269c3ec630e06ae29f74bc39edd1f87c819f1056206e879a1cd61446a65644d6963726f555344": {
    token_id: "8db269c3ec630e06ae29f74bc39edd1f87c819f1056206e879a1cd61446a65644d6963726f555344",
    token_policy: "8db269c3ec630e06ae29f74bc39edd1f87c819f1056206e879a1cd61",
    token_ascii: "Djed USD",
    is_verified: !0,
    ticker: "DJED"
  },
  ee0633e757fdd1423220f43688c74678abde1cead7ce265ba8a24fcd43424c50: {
    token_id: "ee0633e757fdd1423220f43688c74678abde1cead7ce265ba8a24fcd43424c50",
    token_policy: "ee0633e757fdd1423220f43688c74678abde1cead7ce265ba8a24fcd",
    token_ascii: "CBLP",
    is_verified: !0,
    ticker: "CBLP"
  },
  fed1c459a47cbff56bd7d29c2dde0de3e9bd15cee02b98622fce82f743617264616e6f476f6c64: {
    token_id: "fed1c459a47cbff56bd7d29c2dde0de3e9bd15cee02b98622fce82f743617264616e6f476f6c64",
    token_policy: "fed1c459a47cbff56bd7d29c2dde0de3e9bd15cee02b98622fce82f7",
    token_ascii: "Cardano Gold",
    is_verified: !0,
    ticker: "CD"
  },
  "2edc63d29e94747f7ef65df559260c994d2ecfe208ac6afa564517384b494e47": {
    token_id: "2edc63d29e94747f7ef65df559260c994d2ecfe208ac6afa564517384b494e47",
    token_policy: "2edc63d29e94747f7ef65df559260c994d2ecfe208ac6afa56451738",
    token_ascii: "KING",
    is_verified: !0,
    ticker: "KING"
  },
  "4d8469c80677574a5dd23b0fdd0eb0057fb6ce4e20cf21c7e8655f954348524f4d41": {
    token_id: "4d8469c80677574a5dd23b0fdd0eb0057fb6ce4e20cf21c7e8655f954348524f4d41",
    token_policy: "4d8469c80677574a5dd23b0fdd0eb0057fb6ce4e20cf21c7e8655f95",
    token_ascii: "CHROMA",
    is_verified: !0,
    ticker: "CHROMA"
  },
  "29d222ce763455e3d7a09a665ce554f00ac89d2e99a1a83d267170c64d494e74": {
    token_id: "29d222ce763455e3d7a09a665ce554f00ac89d2e99a1a83d267170c64d494e74",
    token_policy: "29d222ce763455e3d7a09a665ce554f00ac89d2e99a1a83d267170c6",
    token_ascii: "Minswap MINt",
    is_verified: !0,
    ticker: "MINt"
  },
  "322490202fbfba723c837c54695d80b61c79ed39dee31dd492391f4b4d6f6e6579": {
    token_id: "322490202fbfba723c837c54695d80b61c79ed39dee31dd492391f4b4d6f6e6579",
    token_policy: "322490202fbfba723c837c54695d80b61c79ed39dee31dd492391f4b",
    token_ascii: "Money",
    is_verified: !0,
    ticker: "MONEY"
  },
  "10a49b996e2402269af553a8a96fb8eb90d79e9eca79e2b4223057b64745524f": {
    token_id: "10a49b996e2402269af553a8a96fb8eb90d79e9eca79e2b4223057b64745524f",
    token_policy: "10a49b996e2402269af553a8a96fb8eb90d79e9eca79e2b4223057b6",
    token_ascii: "GERO",
    is_verified: !0,
    ticker: "GERO"
  },
  "4f771973824f79fff176fe5cc0f29f5f5331a4692e5aa9a0bd0cdde6415058": {
    token_id: "4f771973824f79fff176fe5cc0f29f5f5331a4692e5aa9a0bd0cdde6415058",
    token_policy: "4f771973824f79fff176fe5cc0f29f5f5331a4692e5aa9a0bd0cdde6",
    token_ascii: "APX",
    is_verified: !0,
    ticker: "APX"
  },
  "09f5f55fcad17503e6b7acc81de7c80f84b76e76d17085f0e32f1ce241574f4f": {
    token_id: "09f5f55fcad17503e6b7acc81de7c80f84b76e76d17085f0e32f1ce241574f4f",
    token_policy: "09f5f55fcad17503e6b7acc81de7c80f84b76e76d17085f0e32f1ce2",
    token_ascii: "AWOO Token",
    is_verified: !0,
    ticker: "AWOO"
  },
  b6a7467ea1deb012808ef4e87b5ff371e85f7142d7b356a40d9b42a0436f726e75636f70696173: {
    token_id: "b6a7467ea1deb012808ef4e87b5ff371e85f7142d7b356a40d9b42a0436f726e75636f70696173",
    token_policy: "b6a7467ea1deb012808ef4e87b5ff371e85f7142d7b356a40d9b42a0",
    token_ascii: "TEST TOKEN DO NOT USE",
    is_verified: !0,
    ticker: ""
  },
  "078eafce5cd7edafdf63900edef2c1ea759e77f30ca81d6bbdeec92479756d6d69": {
    token_id: "078eafce5cd7edafdf63900edef2c1ea759e77f30ca81d6bbdeec92479756d6d69",
    token_policy: "078eafce5cd7edafdf63900edef2c1ea759e77f30ca81d6bbdeec924",
    token_ascii: "YUMMI",
    is_verified: !0,
    ticker: "YUMMI"
  },
  c79a25118b06dddc9094a547dd534046ddf9efde264ae1ab9cdf777642756c6c79: {
    token_id: "c79a25118b06dddc9094a547dd534046ddf9efde264ae1ab9cdf777642756c6c79",
    token_policy: "c79a25118b06dddc9094a547dd534046ddf9efde264ae1ab9cdf7776",
    token_ascii: "Bully Doggy",
    is_verified: !0,
    ticker: "BD"
  },
  c490a79c6afd84c5e5dfe487a5fe8b6009c239befff69745c43711ef524f434b4554: {
    token_id: "c490a79c6afd84c5e5dfe487a5fe8b6009c239befff69745c43711ef524f434b4554",
    token_policy: "c490a79c6afd84c5e5dfe487a5fe8b6009c239befff69745c43711ef",
    token_ascii: "ROCKET",
    is_verified: !0,
    ticker: "ROCKET"
  },
  d1407478fb3151f60fc533cd42d806dd7115cecfa25a018baf53c4dc415246: {
    token_id: "d1407478fb3151f60fc533cd42d806dd7115cecfa25a018baf53c4dc415246",
    token_policy: "d1407478fb3151f60fc533cd42d806dd7115cecfa25a018baf53c4dc",
    token_ascii: "ARF",
    is_verified: !0,
    ticker: "ARF"
  },
  "8fef2d34078659493ce161a6c7fba4b56afefa8535296a5743f6958741414441": {
    token_id: "8fef2d34078659493ce161a6c7fba4b56afefa8535296a5743f6958741414441",
    token_policy: "8fef2d34078659493ce161a6c7fba4b56afefa8535296a5743f69587",
    token_ascii: "Lenfi DAO token",
    is_verified: !0,
    ticker: "LENFI"
  },
  "6c8642400e8437f737eb86df0fc8a8437c760f48592b1ba8f5767e81456d706f7761": {
    token_id: "6c8642400e8437f737eb86df0fc8a8437c760f48592b1ba8f5767e81456d706f7761",
    token_policy: "6c8642400e8437f737eb86df0fc8a8437c760f48592b1ba8f5767e81",
    token_ascii: "Empowa",
    is_verified: !0,
    ticker: "EMP"
  },
  "2441ab3351c3b80213a98f4e09ddcf7dabe4879c3c94cc4e7205cb6346495245": {
    token_id: "2441ab3351c3b80213a98f4e09ddcf7dabe4879c3c94cc4e7205cb6346495245",
    token_policy: "2441ab3351c3b80213a98f4e09ddcf7dabe4879c3c94cc4e7205cb63",
    token_ascii: "FIRE",
    is_verified: !0,
    ticker: "FIRE"
  },
  "4623ab311b7d982d8d26fcbe1a9439ca56661aafcdcd8d8a0ef31fd6475245454e53": {
    token_id: "4623ab311b7d982d8d26fcbe1a9439ca56661aafcdcd8d8a0ef31fd6475245454e53",
    token_policy: "4623ab311b7d982d8d26fcbe1a9439ca56661aafcdcd8d8a0ef31fd6",
    token_ascii: "Greens",
    is_verified: !0,
    ticker: "GREENS"
  },
  "8db269c3ec630e06ae29f74bc39edd1f87c819f1056206e879a1cd615368656e4d6963726f555344": {
    token_id: "8db269c3ec630e06ae29f74bc39edd1f87c819f1056206e879a1cd615368656e4d6963726f555344",
    token_policy: "8db269c3ec630e06ae29f74bc39edd1f87c819f1056206e879a1cd61",
    token_ascii: "Shen USD",
    is_verified: !0,
    ticker: "SHEN"
  },
  "92292852e3820cfbe99874b284fdf2befbddb38e070cf3512009a60a47726179506561726c": {
    token_id: "92292852e3820cfbe99874b284fdf2befbddb38e070cf3512009a60a47726179506561726c",
    token_policy: "92292852e3820cfbe99874b284fdf2befbddb38e070cf3512009a60a",
    token_ascii: "Gray Pearl",
    is_verified: !0,
    ticker: "GP"
  },
  edfd7a1d77bcb8b884c474bdc92a16002d1fb720e454fa6e993444794e5458: {
    token_id: "edfd7a1d77bcb8b884c474bdc92a16002d1fb720e454fa6e993444794e5458",
    token_policy: "edfd7a1d77bcb8b884c474bdc92a16002d1fb720e454fa6e99344479",
    token_ascii: "NuNet Utility Token",
    is_verified: !0,
    ticker: "NTX"
  },
  "755a497e592fb6a20337d19d86e1da82d27282db5c9083e0ddaa338c47414c415859": {
    token_id: "755a497e592fb6a20337d19d86e1da82d27282db5c9083e0ddaa338c47414c415859",
    token_policy: "755a497e592fb6a20337d19d86e1da82d27282db5c9083e0ddaa338c",
    token_ascii: "Galaxy",
    is_verified: !0,
    ticker: "GALAXY"
  },
  fccb53cf9d12b07a148c40b349c857bfe2b413cef5cbcf5e6afe7351434f4f4e: {
    token_id: "fccb53cf9d12b07a148c40b349c857bfe2b413cef5cbcf5e6afe7351434f4f4e",
    token_policy: "fccb53cf9d12b07a148c40b349c857bfe2b413cef5cbcf5e6afe7351",
    token_ascii: "COON Coin",
    is_verified: !0,
    ticker: "COON"
  },
  "74be1f6940dadc4ab85c643d7447b45cf4e1b5e9cfd5fed062e903f863617264616e6f2e626c7565": {
    token_id: "74be1f6940dadc4ab85c643d7447b45cf4e1b5e9cfd5fed062e903f863617264616e6f2e626c7565",
    token_policy: "74be1f6940dadc4ab85c643d7447b45cf4e1b5e9cfd5fed062e903f8",
    token_ascii: "cardano.blue",
    is_verified: !0,
    ticker: "CBLUE"
  },
  "23690795536ccf407ed6eeac57db98db9668b3a026991fb516ecd7ef0014df10534d4f4b4553": {
    token_id: "23690795536ccf407ed6eeac57db98db9668b3a026991fb516ecd7ef0014df10534d4f4b4553",
    token_policy: "23690795536ccf407ed6eeac57db98db9668b3a026991fb516ecd7ef",
    token_ascii: "Smokes Token",
    is_verified: !0,
    ticker: "SMOKES"
  },
  "482fb00dc32186a4c587dca2df3c7cf2bc455332ab581d51967306e14d4f4149": {
    token_id: "482fb00dc32186a4c587dca2df3c7cf2bc455332ab581d51967306e14d4f4149",
    token_policy: "482fb00dc32186a4c587dca2df3c7cf2bc455332ab581d51967306e1",
    token_ascii: "MOAI",
    is_verified: !0,
    ticker: "MOAI"
  },
  c448753e6dac6d4d3508e47f636122c715e3c8575955ae77307b305f696e76616461: {
    token_id: "c448753e6dac6d4d3508e47f636122c715e3c8575955ae77307b305f696e76616461",
    token_policy: "c448753e6dac6d4d3508e47f636122c715e3c8575955ae77307b305f",
    token_ascii: "invada",
    is_verified: !0,
    ticker: "invada"
  },
  "89267e9a35153a419e1b8ffa23e511ac39ea4e3b00452e9d500f2982436176616c6965724b696e67436861726c6573": {
    token_id: "89267e9a35153a419e1b8ffa23e511ac39ea4e3b00452e9d500f2982436176616c6965724b696e67436861726c6573",
    token_policy: "89267e9a35153a419e1b8ffa23e511ac39ea4e3b00452e9d500f2982",
    token_ascii: "Cavalier King Charles token",
    is_verified: !0,
    ticker: "Charly"
  },
  "4342a3d3c15545a592bf38294dc75c7a1dd3550388303e3a06f4416d4345525241": {
    token_id: "4342a3d3c15545a592bf38294dc75c7a1dd3550388303e3a06f4416d4345525241",
    token_policy: "4342a3d3c15545a592bf38294dc75c7a1dd3550388303e3a06f4416d",
    token_ascii: "CERRA",
    is_verified: !0,
    ticker: "CERRA"
  },
  "8499f3958a114d03b6289185138a60378951a2b5491cb2a080ff7b6e504d58": {
    token_id: "8499f3958a114d03b6289185138a60378951a2b5491cb2a080ff7b6e504d58",
    token_policy: "8499f3958a114d03b6289185138a60378951a2b5491cb2a080ff7b6e",
    token_ascii: "PlayerMint",
    is_verified: !0,
    ticker: "PMX"
  },
  "9a9693a9a37912a5097918f97918d15240c92ab729a0b7c4aa144d7753554e444145": {
    token_id: "9a9693a9a37912a5097918f97918d15240c92ab729a0b7c4aa144d7753554e444145",
    token_policy: "9a9693a9a37912a5097918f97918d15240c92ab729a0b7c4aa144d77",
    token_ascii: "SUNDAE",
    is_verified: !0,
    ticker: "SUNDAE"
  },
  "64c3ebd40ed377989aa3069a2936e07c6ce82df46688c473d921520664676166": {
    token_id: "64c3ebd40ed377989aa3069a2936e07c6ce82df46688c473d921520664676166",
    token_policy: "64c3ebd40ed377989aa3069a2936e07c6ce82df46688c473d9215206",
    token_ascii: "DGAF",
    is_verified: !0,
    ticker: "DGAF"
  },
  ca942cb8bb5d1ef750766ded355f320880539111f10efa2b1a478ff9524147: {
    token_id: "ca942cb8bb5d1ef750766ded355f320880539111f10efa2b1a478ff9524147",
    token_policy: "ca942cb8bb5d1ef750766ded355f320880539111f10efa2b1a478ff9",
    token_ascii: "RaggieCoin",
    is_verified: !0,
    ticker: "RAG"
  },
  "0fc1a2c01b3b96e6fc18681852c26d904b4ca180150671e1b250369f464f524745": {
    token_id: "0fc1a2c01b3b96e6fc18681852c26d904b4ca180150671e1b250369f464f524745",
    token_policy: "0fc1a2c01b3b96e6fc18681852c26d904b4ca180150671e1b250369f",
    token_ascii: "Forge Credits",
    is_verified: !0,
    ticker: "FORGE"
  },
  "4756b1e7626e84c6de4fe4256b874412c5529a8e75b707ba1e677f4642455043": {
    token_id: "4756b1e7626e84c6de4fe4256b874412c5529a8e75b707ba1e677f4642455043",
    token_policy: "4756b1e7626e84c6de4fe4256b874412c5529a8e75b707ba1e677f46",
    token_ascii: "BEPC",
    is_verified: !0,
    ticker: "BEPC"
  },
  "454669a208d486fe98c6eca9070c62df7fc8449d1bf6237a5fe1aa11465849": {
    token_id: "454669a208d486fe98c6eca9070c62df7fc8449d1bf6237a5fe1aa11465849",
    token_policy: "454669a208d486fe98c6eca9070c62df7fc8449d1bf6237a5fe1aa11",
    token_ascii: "FOXINU",
    is_verified: !0,
    ticker: "FXI"
  },
  "07ccfad78099fef727bfc64de1cf2e684c0872aab3c3bb3bed5e1081706565706565": {
    token_id: "07ccfad78099fef727bfc64de1cf2e684c0872aab3c3bb3bed5e1081706565706565",
    token_policy: "07ccfad78099fef727bfc64de1cf2e684c0872aab3c3bb3bed5e1081",
    token_ascii: "PeePeeToken",
    is_verified: !0,
    ticker: "PEEPEE"
  },
  "87a59599f8f47db431de642329a275cd4b297f21f1517af9db442cee506f705570576f726c64": {
    token_id: "87a59599f8f47db431de642329a275cd4b297f21f1517af9db442cee506f705570576f726c64",
    token_policy: "87a59599f8f47db431de642329a275cd4b297f21f1517af9db442cee",
    token_ascii: "PopUpWorld",
    is_verified: !0,
    ticker: "PUW"
  },
  bbd0ec94cf9ccc1407b3dbc66bfbbff82ea49718ae4e3dceb817125f24574f524b: {
    token_id: "bbd0ec94cf9ccc1407b3dbc66bfbbff82ea49718ae4e3dceb817125f24574f524b",
    token_policy: "bbd0ec94cf9ccc1407b3dbc66bfbbff82ea49718ae4e3dceb817125f",
    token_ascii: "WORK",
    is_verified: !0,
    ticker: "WORK"
  },
  ace2ea0fe142a3687acf86f55bcded860a920864163ee0d3dda8b60252414b4552: {
    token_id: "ace2ea0fe142a3687acf86f55bcded860a920864163ee0d3dda8b60252414b4552",
    token_policy: "ace2ea0fe142a3687acf86f55bcded860a920864163ee0d3dda8b602",
    token_ascii: "MarketRaker",
    is_verified: !0,
    ticker: "RAKER"
  },
  "2b28c81dbba6d67e4b5a997c6be1212cba9d60d33f82444ab8b1f21842414e4b": {
    token_id: "2b28c81dbba6d67e4b5a997c6be1212cba9d60d33f82444ab8b1f21842414e4b",
    token_policy: "2b28c81dbba6d67e4b5a997c6be1212cba9d60d33f82444ab8b1f218",
    token_ascii: "Bankercoin",
    is_verified: !0,
    ticker: "BANK"
  },
  "681b5d0383ac3b457e1bcc453223c90ccef26b234328f45fa10fd2764a5047": {
    token_id: "681b5d0383ac3b457e1bcc453223c90ccef26b234328f45fa10fd2764a5047",
    token_policy: "681b5d0383ac3b457e1bcc453223c90ccef26b234328f45fa10fd276",
    token_ascii: "JPG",
    is_verified: !0,
    ticker: "JPG",
    decimals: 6
  },
  b6a7467ea1deb012808ef4e87b5ff371e85f7142d7b356a40d9b42a0436f726e75636f70696173205b76696120436861696e506f72742e696f5d: {
    token_id: "b6a7467ea1deb012808ef4e87b5ff371e85f7142d7b356a40d9b42a0436f726e75636f70696173205b76696120436861696e506f72742e696f5d",
    token_policy: "b6a7467ea1deb012808ef4e87b5ff371e85f7142d7b356a40d9b42a0",
    token_ascii: "Cornucopias Token",
    is_verified: !0,
    ticker: "COPI"
  },
  db30c7905f598ed0154de14f970de0f61f0cb3943ed82c891968480a434c4150: {
    token_id: "db30c7905f598ed0154de14f970de0f61f0cb3943ed82c891968480a434c4150",
    token_policy: "db30c7905f598ed0154de14f970de0f61f0cb3943ed82c891968480a",
    token_ascii: "CLAP",
    is_verified: !0,
    ticker: "CLAP"
  },
  "8be741cb809416f0785837d00a0fba01de42e3580d96e378f82b24ab427574746572": {
    token_id: "8be741cb809416f0785837d00a0fba01de42e3580d96e378f82b24ab427574746572",
    token_policy: "8be741cb809416f0785837d00a0fba01de42e3580d96e378f82b24ab",
    token_ascii: "Butter",
    is_verified: !0,
    ticker: "Butter"
  },
  "7e4f764cd4283d99b2bbf532d80e8105c3ae58a21b089bce8068170b4745434b": {
    token_id: "7e4f764cd4283d99b2bbf532d80e8105c3ae58a21b089bce8068170b4745434b",
    token_policy: "7e4f764cd4283d99b2bbf532d80e8105c3ae58a21b089bce8068170b",
    token_ascii: "GECK",
    is_verified: !0,
    ticker: "GECK"
  },
  "0d90046ad35546156aaf790525133f7fc713ca2790e397784b85f5c85554494c": {
    token_id: "0d90046ad35546156aaf790525133f7fc713ca2790e397784b85f5c85554494c",
    token_policy: "0d90046ad35546156aaf790525133f7fc713ca2790e397784b85f5c8",
    token_ascii: "Utility Token",
    is_verified: !0,
    ticker: "UTIL"
  },
  "4ed5b703c146c25c09516f4b83aab31f44f7c55cdc159866e49731534f504f43": {
    token_id: "4ed5b703c146c25c09516f4b83aab31f44f7c55cdc159866e49731534f504f43",
    token_policy: "4ed5b703c146c25c09516f4b83aab31f44f7c55cdc159866e4973153",
    token_ascii: "OPOC",
    is_verified: !0,
    ticker: "OPOC"
  },
  "38ad9dc3aec6a2f38e220142b9aa6ade63ebe71f65e7cc2b7d8a8535434c4159": {
    token_id: "38ad9dc3aec6a2f38e220142b9aa6ade63ebe71f65e7cc2b7d8a8535434c4159",
    token_policy: "38ad9dc3aec6a2f38e220142b9aa6ade63ebe71f65e7cc2b7d8a8535",
    token_ascii: "CLAY",
    is_verified: !0,
    ticker: "CLAY"
  },
  "885742cd7e0dad321622b5d3ad186797bd50c44cbde8b48be1583fbd534b554c4c": {
    token_id: "885742cd7e0dad321622b5d3ad186797bd50c44cbde8b48be1583fbd534b554c4c",
    token_policy: "885742cd7e0dad321622b5d3ad186797bd50c44cbde8b48be1583fbd",
    token_ascii: "SKULL",
    is_verified: !0,
    ticker: "SKULL"
  },
  "8a1cfae21368b8bebbbed9800fec304e95cce39a2a57dc35e2e3ebaa4d494c4b": {
    token_id: "8a1cfae21368b8bebbbed9800fec304e95cce39a2a57dc35e2e3ebaa4d494c4b",
    token_policy: "8a1cfae21368b8bebbbed9800fec304e95cce39a2a57dc35e2e3ebaa",
    token_ascii: "MILK",
    is_verified: !0,
    ticker: "MILK"
  },
  a1b284d7218dd63772c67ca26ab73721a196b404929cddef595f9967574f4a414b424c5545: {
    token_id: "a1b284d7218dd63772c67ca26ab73721a196b404929cddef595f9967574f4a414b424c5545",
    token_policy: "a1b284d7218dd63772c67ca26ab73721a196b404929cddef595f9967",
    token_ascii: "Wojak Blue",
    is_verified: !0,
    ticker: "WOJAKBLUE"
  },
  "52162581184a457fad70470161179c5766f00237d4b67e0f1df1b4e65452544c": {
    token_id: "52162581184a457fad70470161179c5766f00237d4b67e0f1df1b4e65452544c",
    token_policy: "52162581184a457fad70470161179c5766f00237d4b67e0f1df1b4e6",
    token_ascii: "Tortol",
    is_verified: !0,
    ticker: "TRTL"
  },
  "5acc52d5696e52345aec108468050d9d743eb21d6e41305bbc23a27b4154484f4d": {
    token_id: "5acc52d5696e52345aec108468050d9d743eb21d6e41305bbc23a27b4154484f4d",
    token_policy: "5acc52d5696e52345aec108468050d9d743eb21d6e41305bbc23a27b",
    token_ascii: "ATHOM",
    is_verified: !0,
    ticker: "ATH"
  },
  "1b99120f61cd9c30938661b5144a352857431a14b2334faef8a180c7424644526f636b6574436f696e": {
    token_id: "1b99120f61cd9c30938661b5144a352857431a14b2334faef8a180c7424644526f636b6574436f696e",
    token_policy: "1b99120f61cd9c30938661b5144a352857431a14b2334faef8a180c7",
    token_ascii: "BFD Rocket Coin",
    is_verified: !0,
    ticker: "BFD"
  },
  c69b36d2939ca42bf3d8c1dae2bfed9e8a4c34dc3f002ff3782227c044414e5a4f: {
    token_id: "c69b36d2939ca42bf3d8c1dae2bfed9e8a4c34dc3f002ff3782227c044414e5a4f",
    token_policy: "c69b36d2939ca42bf3d8c1dae2bfed9e8a4c34dc3f002ff3782227c0",
    token_ascii: "Cardanzo",
    is_verified: !0,
    ticker: "DANZO"
  },
  "96abe9a17b65c2133ed7e11864338e965efc418c0961ceecfac1617259455449": {
    token_id: "96abe9a17b65c2133ed7e11864338e965efc418c0961ceecfac1617259455449",
    token_policy: "96abe9a17b65c2133ed7e11864338e965efc418c0961ceecfac16172",
    token_ascii: "YETI",
    is_verified: !0,
    ticker: "YETI"
  },
  "5dac8536653edc12f6f5e1045d8164b9f59998d3bdc300fc928434894e4d4b52": {
    token_id: "5dac8536653edc12f6f5e1045d8164b9f59998d3bdc300fc928434894e4d4b52",
    token_policy: "5dac8536653edc12f6f5e1045d8164b9f59998d3bdc300fc92843489",
    token_ascii: "NMKR",
    is_verified: !0,
    ticker: "NMKR"
  },
  "92292852e3820cfbe99874b284fdf2befbddb38e070cf3512009a60a5768697465506561726c": {
    token_id: "92292852e3820cfbe99874b284fdf2befbddb38e070cf3512009a60a5768697465506561726c",
    token_policy: "92292852e3820cfbe99874b284fdf2befbddb38e070cf3512009a60a",
    token_ascii: "White Pearl",
    is_verified: !0,
    ticker: "WP"
  },
  e88e1e4d7e5c807a4c325d7d7d6bba98eaa4d53c2b8c0ff5ae5187326444: {
    token_id: "e88e1e4d7e5c807a4c325d7d7d6bba98eaa4d53c2b8c0ff5ae5187326444",
    token_policy: "e88e1e4d7e5c807a4c325d7d7d6bba98eaa4d53c2b8c0ff5ae518732",
    token_ascii: "dollarDyne",
    is_verified: !0,
    ticker: "dD"
  },
  "6ac8ef33b510ec004fe11585f7c5a9f0c07f0c23428ab4f29c1d7d104d454c44": {
    token_id: "6ac8ef33b510ec004fe11585f7c5a9f0c07f0c23428ab4f29c1d7d104d454c44",
    token_policy: "6ac8ef33b510ec004fe11585f7c5a9f0c07f0c23428ab4f29c1d7d10",
    token_ascii: "MELD",
    is_verified: !0,
    ticker: "MELD"
  },
  "71ccb467ef856b242753ca53ade36cd1f8d9abb33fdfa7d1ff89cda3434643": {
    token_id: "71ccb467ef856b242753ca53ade36cd1f8d9abb33fdfa7d1ff89cda3434643",
    token_policy: "71ccb467ef856b242753ca53ade36cd1f8d9abb33fdfa7d1ff89cda3",
    token_ascii: "CFC Token",
    is_verified: !0,
    ticker: "CFC"
  },
  d244fcb1d038951eb4fcdba0cc77299453ec96d18ac786ccd284cc784c657879: {
    token_id: "d244fcb1d038951eb4fcdba0cc77299453ec96d18ac786ccd284cc784c657879",
    token_policy: "d244fcb1d038951eb4fcdba0cc77299453ec96d18ac786ccd284cc78",
    token_ascii: "Lexy",
    is_verified: !0,
    ticker: "LEXY"
  },
  fed1c459a47cbff56bd7d29c2dde0de3e9bd15cee02b98622fce82f743617264616e6f53696c766572: {
    token_id: "fed1c459a47cbff56bd7d29c2dde0de3e9bd15cee02b98622fce82f743617264616e6f53696c766572",
    token_policy: "fed1c459a47cbff56bd7d29c2dde0de3e9bd15cee02b98622fce82f7",
    token_ascii: "Cardano Silver",
    is_verified: !0,
    ticker: "CD"
  },
  f66d78b4a3cb3d37afa0ec36461e51ecbde00f26c8f0a68f94b6988069455448: {
    token_id: "f66d78b4a3cb3d37afa0ec36461e51ecbde00f26c8f0a68f94b6988069455448",
    token_policy: "f66d78b4a3cb3d37afa0ec36461e51ecbde00f26c8f0a68f94b69880",
    token_ascii: "iETH",
    is_verified: !0,
    ticker: "iETH"
  },
  "94a21344f388a259dc8b1f3bcf91d9439379dd748b18a7168ed0b35976414441": {
    token_id: "94a21344f388a259dc8b1f3bcf91d9439379dd748b18a7168ed0b35976414441",
    token_policy: "94a21344f388a259dc8b1f3bcf91d9439379dd748b18a7168ed0b359",
    token_ascii: "vADA",
    is_verified: !0,
    ticker: "vADA"
  },
  dda5fdb1002f7389b33e036b6afee82a8189becb6cba852e8b79b4fb0014df1047454e53: {
    token_id: "dda5fdb1002f7389b33e036b6afee82a8189becb6cba852e8b79b4fb0014df1047454e53",
    token_policy: "dda5fdb1002f7389b33e036b6afee82a8189becb6cba852e8b79b4fb",
    token_ascii: "Genius Yield Token",
    is_verified: !0,
    ticker: "GENS"
  },
  fffb818d86ad49314e29379db26680c9669002ce72f2f1f6c2f761ce466f787879: {
    token_id: "fffb818d86ad49314e29379db26680c9669002ce72f2f1f6c2f761ce466f787879",
    token_policy: "fffb818d86ad49314e29379db26680c9669002ce72f2f1f6c2f761ce",
    token_ascii: "Foxxy",
    is_verified: !0,
    ticker: ""
  },
  "4190b2941d9be04acc69c39739bd5acc66d60ccab480d8e20bc87e3763425443": {
    token_id: "4190b2941d9be04acc69c39739bd5acc66d60ccab480d8e20bc87e3763425443",
    token_policy: "4190b2941d9be04acc69c39739bd5acc66d60ccab480d8e20bc87e37",
    token_ascii: "cBTC",
    is_verified: !0,
    ticker: "cBTC"
  },
  "7ced2090df97de4a4c25a6be62a916cfdd4ad794a828fbb743b2d56e444544": {
    token_id: "7ced2090df97de4a4c25a6be62a916cfdd4ad794a828fbb743b2d56e444544",
    token_policy: "7ced2090df97de4a4c25a6be62a916cfdd4ad794a828fbb743b2d56e",
    token_ascii: "DEDCOIN",
    is_verified: !0,
    ticker: "DED"
  },
  eef4f770d16d2d4c09f0eae47eec8a6c13244d772f45ee41fc822c944352444f: {
    token_id: "eef4f770d16d2d4c09f0eae47eec8a6c13244d772f45ee41fc822c944352444f",
    token_policy: "eef4f770d16d2d4c09f0eae47eec8a6c13244d772f45ee41fc822c94",
    token_ascii: "Crazy Donkeys Token",
    is_verified: !0,
    ticker: "CRDO"
  },
  "75fcc276057db5fc48eae0e11453c773c8a54604c3086bf9d95ac1b743485259": {
    token_id: "75fcc276057db5fc48eae0e11453c773c8a54604c3086bf9d95ac1b743485259",
    token_policy: "75fcc276057db5fc48eae0e11453c773c8a54604c3086bf9d95ac1b7",
    token_ascii: "CherryLend",
    is_verified: !0,
    ticker: "CHRY"
  },
  b9168f05e657b6946fede254e383586cf7e7a2573d5a0fa12b3ef6ac494450: {
    token_id: "b9168f05e657b6946fede254e383586cf7e7a2573d5a0fa12b3ef6ac494450",
    token_policy: "b9168f05e657b6946fede254e383586cf7e7a2573d5a0fa12b3ef6ac",
    token_ascii: "IDO Pass DAO Utility Token",
    is_verified: !0,
    ticker: "IDP"
  },
  "88c7fe7cf68625fd24dc3405432684ae85da094dceff25f81d6664fd5a4f4d424945": {
    token_id: "88c7fe7cf68625fd24dc3405432684ae85da094dceff25f81d6664fd5a4f4d424945",
    token_policy: "88c7fe7cf68625fd24dc3405432684ae85da094dceff25f81d6664fd",
    token_ascii: "Zombie",
    is_verified: !0,
    ticker: "ZOMBIE"
  },
  "007394e3117755fbb0558b93c54ce3bc6c85770920044ade143dc742505443": {
    token_id: "007394e3117755fbb0558b93c54ce3bc6c85770920044ade143dc742505443",
    token_policy: "007394e3117755fbb0558b93c54ce3bc6c85770920044ade143dc742",
    token_ascii: "Pocket Change",
    is_verified: !0,
    ticker: "PTC"
  },
  "16fdd33c86af604e837ae57d79d5f0f1156406086db5f16afb3fcf5144474f4c44": {
    token_id: "16fdd33c86af604e837ae57d79d5f0f1156406086db5f16afb3fcf5144474f4c44",
    token_policy: "16fdd33c86af604e837ae57d79d5f0f1156406086db5f16afb3fcf51",
    token_ascii: "Digital Gold Token",
    is_verified: !0,
    ticker: "DGOLD"
  },
  "9d86482511c8a49f21d5c83ee58a49e2926f70ac57dd73ed204042697175657374": {
    token_id: "9d86482511c8a49f21d5c83ee58a49e2926f70ac57dd73ed204042697175657374",
    token_policy: "9d86482511c8a49f21d5c83ee58a49e2926f70ac57dd73ed20404269",
    token_ascii: "QuestToken",
    is_verified: !0,
    ticker: "QTS"
  },
  "7914fae20eb2903ed6fd5021a415c1bd2626b64a2d86a304cb40ff5e4c494649": {
    token_id: "7914fae20eb2903ed6fd5021a415c1bd2626b64a2d86a304cb40ff5e4c494649",
    token_policy: "7914fae20eb2903ed6fd5021a415c1bd2626b64a2d86a304cb40ff5e",
    token_ascii: "LinkageFinanceToken",
    is_verified: !0,
    ticker: "LIFI"
  },
  "07f019ce45fb638353258bda4316ce5eb3d0f76a3fb739c45174084953414c5459": {
    token_id: "07f019ce45fb638353258bda4316ce5eb3d0f76a3fb739c45174084953414c5459",
    token_policy: "07f019ce45fb638353258bda4316ce5eb3d0f76a3fb739c451740849",
    token_ascii: "Salty Seagulls Society Token",
    is_verified: !0,
    ticker: "SALTY"
  },
  "438514ae1beb020d35e5389993447cea29637d6272c918017988ef364164615969656c64": {
    token_id: "438514ae1beb020d35e5389993447cea29637d6272c918017988ef364164615969656c64",
    token_policy: "438514ae1beb020d35e5389993447cea29637d6272c918017988ef36",
    token_ascii: "AdaYield",
    is_verified: !0,
    ticker: "ADY"
  },
  "3ee8e0824a7a81bdc5bcacd004c25d3264dd8ac3eb4ab877b5d7d0ce6b656b77": {
    token_id: "3ee8e0824a7a81bdc5bcacd004c25d3264dd8ac3eb4ab877b5d7d0ce6b656b77",
    token_policy: "3ee8e0824a7a81bdc5bcacd004c25d3264dd8ac3eb4ab877b5d7d0ce",
    token_ascii: "kekw",
    is_verified: !0,
    ticker: "kekw"
  },
  "37a2b93b4aa2b286b92b7099faff0bb87e0c629a5079c0584da2d5774f534d": {
    token_id: "37a2b93b4aa2b286b92b7099faff0bb87e0c629a5079c0584da2d5774f534d",
    token_policy: "37a2b93b4aa2b286b92b7099faff0bb87e0c629a5079c0584da2d577",
    token_ascii: "OsmiumDAO Token",
    is_verified: !0,
    ticker: "OSM"
  },
  afc910d7a306d20c12903979d4935ae4307241d03245743548e767834153484942: {
    token_id: "afc910d7a306d20c12903979d4935ae4307241d03245743548e767834153484942",
    token_policy: "afc910d7a306d20c12903979d4935ae4307241d03245743548e76783",
    token_ascii: "ADA Shiba Inu",
    is_verified: !0,
    ticker: "ASHIB"
  },
  "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c50757061436f696e": {
    token_id: "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c50757061436f696e",
    token_policy: "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c",
    token_ascii: "PupaCoin",
    is_verified: !0,
    ticker: "wPPCN"
  },
  "15637826ecbdb4e5747fd41f830d9735a8c4e6d927e44d29ceef9e885a4f4f": {
    token_id: "15637826ecbdb4e5747fd41f830d9735a8c4e6d927e44d29ceef9e885a4f4f",
    token_policy: "15637826ecbdb4e5747fd41f830d9735a8c4e6d927e44d29ceef9e88",
    token_ascii: "ZOO",
    is_verified: !0,
    ticker: "ZOO"
  },
  b0af30edf2c7f11465853821137e0a6ebc395cab71ee39c24127ffb44e465443: {
    token_id: "b0af30edf2c7f11465853821137e0a6ebc395cab71ee39c24127ffb44e465443",
    token_policy: "b0af30edf2c7f11465853821137e0a6ebc395cab71ee39c24127ffb4",
    token_ascii: "NFT Creative Coin",
    is_verified: !0,
    ticker: "NFTC"
  },
  f4d97191f857096b441a410c036f63d6697dde0c71d2755dd664e3024d4b41: {
    token_id: "f4d97191f857096b441a410c036f63d6697dde0c71d2755dd664e3024d4b41",
    token_policy: "f4d97191f857096b441a410c036f63d6697dde0c71d2755dd664e302",
    token_ascii: "Merkaba",
    is_verified: !0,
    ticker: "MKA"
  },
  "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c44696d696e7574697665436f696e": {
    token_id: "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c44696d696e7574697665436f696e",
    token_policy: "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c",
    token_ascii: "DiminutiveCoin",
    is_verified: !0,
    ticker: "wDIMI"
  },
  "21abdf54f427b378fe9ba07419eff6e8e8fe0c5932e1fee2d3853b9350455045424c5545": {
    token_id: "21abdf54f427b378fe9ba07419eff6e8e8fe0c5932e1fee2d3853b9350455045424c5545",
    token_policy: "21abdf54f427b378fe9ba07419eff6e8e8fe0c5932e1fee2d3853b93",
    token_ascii: "PEPE BLUE",
    is_verified: !0,
    ticker: ""
  },
  f6ac48c64aa7af16434d9f84e014d11fba38525b436acc338ff20b0d4d7463: {
    token_id: "f6ac48c64aa7af16434d9f84e014d11fba38525b436acc338ff20b0d4d7463",
    token_policy: "f6ac48c64aa7af16434d9f84e014d11fba38525b436acc338ff20b0d",
    token_ascii: "Mithrandir Coin",
    is_verified: !0,
    ticker: "Mtc"
  },
  "8f52f6a88acf6127bc4758a16b6047afc4da7887feae121ec217b75a534e4f57": {
    token_id: "8f52f6a88acf6127bc4758a16b6047afc4da7887feae121ec217b75a534e4f57",
    token_policy: "8f52f6a88acf6127bc4758a16b6047afc4da7887feae121ec217b75a",
    token_ascii: "SNOW",
    is_verified: !0,
    ticker: "SNOW"
  },
  "12d5f4fefe222d52a4fdcee56f4b272911d7c2202b068a08ebf5327049414d58": {
    token_id: "12d5f4fefe222d52a4fdcee56f4b272911d7c2202b068a08ebf5327049414d58",
    token_policy: "12d5f4fefe222d52a4fdcee56f4b272911d7c2202b068a08ebf53270",
    token_ascii: "IAMX",
    is_verified: !0,
    ticker: "IAMX"
  },
  "8daefa391220bd0d8d007f3748d870f7f3c106040314c8515ccc35a5464c4143": {
    token_id: "8daefa391220bd0d8d007f3748d870f7f3c106040314c8515ccc35a5464c4143",
    token_policy: "8daefa391220bd0d8d007f3748d870f7f3c106040314c8515ccc35a5",
    token_ascii: "Flac Finance",
    is_verified: !0,
    ticker: "FLAC"
  },
  "585cfcbdd0786e961187999e5d5d36b38d1ebc1c4112a0a95a8bd477424c43": {
    token_id: "585cfcbdd0786e961187999e5d5d36b38d1ebc1c4112a0a95a8bd477424c43",
    token_policy: "585cfcbdd0786e961187999e5d5d36b38d1ebc1c4112a0a95a8bd477",
    token_ascii: "Ibilecoin",
    is_verified: !0,
    ticker: "BLC"
  },
  f4364875e75320d405ceadebdf0db63fadaff55c72d4ff6b82f0676a434152474f: {
    token_id: "f4364875e75320d405ceadebdf0db63fadaff55c72d4ff6b82f0676a434152474f",
    token_policy: "f4364875e75320d405ceadebdf0db63fadaff55c72d4ff6b82f0676a",
    token_ascii: "Cardano Gold",
    is_verified: !0,
    ticker: "CARGO"
  },
  ddeec4b6d0c03b6ba4c6135e8e81031748554a5626c23363878f53dd44554d50: {
    token_id: "ddeec4b6d0c03b6ba4c6135e8e81031748554a5626c23363878f53dd44554d50",
    token_policy: "ddeec4b6d0c03b6ba4c6135e8e81031748554a5626c23363878f53dd",
    token_ascii: "$DUMP",
    is_verified: !0,
    ticker: "DUMP"
  },
  c8764cd53485b29f6ad94bf69f399ac72903b4df1e70d6a119d6596e4859445241: {
    token_id: "c8764cd53485b29f6ad94bf69f399ac72903b4df1e70d6a119d6596e4859445241",
    token_policy: "c8764cd53485b29f6ad94bf69f399ac72903b4df1e70d6a119d6596e",
    token_ascii: "HYDRA",
    is_verified: !0,
    ticker: "HYDRA"
  },
  "09f5f55fcad17503e6b7acc81de7c80f84b76e76d17085f0e32f1ce22d6d2041574f4f0a": {
    token_id: "09f5f55fcad17503e6b7acc81de7c80f84b76e76d17085f0e32f1ce22d6d2041574f4f0a",
    token_policy: "09f5f55fcad17503e6b7acc81de7c80f84b76e76d17085f0e32f1ce2",
    token_ascii: "AWOO Token",
    is_verified: !0,
    ticker: "AWOO"
  },
  bb4cfbe0f6be60b80f90f815e8353b93431de4df785d75350b9d214a48455242: {
    token_id: "bb4cfbe0f6be60b80f90f815e8353b93431de4df785d75350b9d214a48455242",
    token_policy: "bb4cfbe0f6be60b80f90f815e8353b93431de4df785d75350b9d214a",
    token_ascii: "ADA BUDZ HERB",
    is_verified: !0,
    ticker: "HERB"
  },
  "1a71dc14baa0b4fcfb34464adc6656d0e562571e2ac1bc990c9ce5f6574f4c46": {
    token_id: "1a71dc14baa0b4fcfb34464adc6656d0e562571e2ac1bc990c9ce5f6574f4c46",
    token_policy: "1a71dc14baa0b4fcfb34464adc6656d0e562571e2ac1bc990c9ce5f6",
    token_ascii: "$WOLF",
    is_verified: !0,
    ticker: "WOLF"
  },
  "493136618a39dcefb89ff573061f715ee32e88092d0299c54e3a377356595241": {
    token_id: "493136618a39dcefb89ff573061f715ee32e88092d0299c54e3a377356595241",
    token_policy: "493136618a39dcefb89ff573061f715ee32e88092d0299c54e3a3773",
    token_ascii: "VYRA",
    is_verified: !0,
    ticker: "VYRA"
  },
  fce30a7f7d16e48c69a7847ec908fe098a0efa0dbc99bad8e2aec15a69646f6c: {
    token_id: "fce30a7f7d16e48c69a7847ec908fe098a0efa0dbc99bad8e2aec15a69646f6c",
    token_policy: "fce30a7f7d16e48c69a7847ec908fe098a0efa0dbc99bad8e2aec15a",
    token_ascii: "IDOL",
    is_verified: !0,
    ticker: "IDOL"
  },
  "6106ab6d8912a8f7e08b5d3300d5f8bdd6371793caceee7e0859868547617279546865436c6f776e": {
    token_id: "6106ab6d8912a8f7e08b5d3300d5f8bdd6371793caceee7e0859868547617279546865436c6f776e",
    token_policy: "6106ab6d8912a8f7e08b5d3300d5f8bdd6371793caceee7e08598685",
    token_ascii: "GaryTheClownCBDC",
    is_verified: !0,
    ticker: "$GaryCBDC"
  },
  fed1c459a47cbff56bd7d29c2dde0de3e9bd15cee02b98622fce82f743617264616e6f436f70706572: {
    token_id: "fed1c459a47cbff56bd7d29c2dde0de3e9bd15cee02b98622fce82f743617264616e6f436f70706572",
    token_policy: "fed1c459a47cbff56bd7d29c2dde0de3e9bd15cee02b98622fce82f7",
    token_ascii: "Cardano Copper",
    is_verified: !0,
    ticker: "CD"
  },
  ab3e31c490d248c592d5bb495823a45fd10f9c8e4f561f13551803fb43617264616e6f20436f6d6d756e697479204368617269747920436f696e: {
    token_id: "ab3e31c490d248c592d5bb495823a45fd10f9c8e4f561f13551803fb43617264616e6f20436f6d6d756e697479204368617269747920436f696e",
    token_policy: "ab3e31c490d248c592d5bb495823a45fd10f9c8e4f561f13551803fb",
    token_ascii: "Cardano Community Charity Coin",
    is_verified: !0,
    ticker: "CCCC"
  },
  ee7ffc3c9402a4b75de30574d631546492bb4a448cc8966fd994ba30435241434b: {
    token_id: "ee7ffc3c9402a4b75de30574d631546492bb4a448cc8966fd994ba30435241434b",
    token_policy: "ee7ffc3c9402a4b75de30574d631546492bb4a448cc8966fd994ba30",
    token_ascii: "CRACK",
    is_verified: !0,
    ticker: "CRACK"
  },
  "6d03347cbf9d02ace480933170b190844f61ead0477c0bd0e53bb4dd5354494e4b59": {
    token_id: "6d03347cbf9d02ace480933170b190844f61ead0477c0bd0e53bb4dd5354494e4b59",
    token_policy: "6d03347cbf9d02ace480933170b190844f61ead0477c0bd0e53bb4dd",
    token_ascii: "STINKY",
    is_verified: !0,
    ticker: "$STINKY"
  },
  "47959e79846b8bdcacb91f586408d97e2dff44f31a04f03902cba8185357454554": {
    token_id: "47959e79846b8bdcacb91f586408d97e2dff44f31a04f03902cba8185357454554",
    token_policy: "47959e79846b8bdcacb91f586408d97e2dff44f31a04f03902cba818",
    token_ascii: "SWEET",
    is_verified: !0,
    ticker: "SWEET"
  },
  c7dcfa416c127f630b263c7e0fe0564430cfa9c56bba43e1a37c6915474f4b4559: {
    token_id: "c7dcfa416c127f630b263c7e0fe0564430cfa9c56bba43e1a37c6915474f4b4559",
    token_policy: "c7dcfa416c127f630b263c7e0fe0564430cfa9c56bba43e1a37c6915",
    token_ascii: "GoKey",
    is_verified: !0,
    ticker: "GOKEY"
  },
  fb0e9a083ac66c814548002cbdfc54557e064e4cdf5c6675e72d22b44445414e: {
    token_id: "fb0e9a083ac66c814548002cbdfc54557e064e4cdf5c6675e72d22b44445414e",
    token_policy: "fb0e9a083ac66c814548002cbdfc54557e064e4cdf5c6675e72d22b4",
    token_ascii: "DEAN",
    is_verified: !0,
    ticker: "DEAN"
  },
  "12274673b36fa1507084eae4b9f78d28bd67266396331f46528c397461647568": {
    token_id: "12274673b36fa1507084eae4b9f78d28bd67266396331f46528c397461647568",
    token_policy: "12274673b36fa1507084eae4b9f78d28bd67266396331f46528c3974",
    token_ascii: "ADUH",
    is_verified: !0,
    ticker: "ADUH"
  },
  a4da8764a57e66a0085b5bfcde96c89b798d92ee83a75f59237e375b46495245: {
    token_id: "a4da8764a57e66a0085b5bfcde96c89b798d92ee83a75f59237e375b46495245",
    token_policy: "a4da8764a57e66a0085b5bfcde96c89b798d92ee83a75f59237e375b",
    token_ascii: "FIRE Token",
    is_verified: !0,
    ticker: "FIRE"
  },
  "5612bee388219c1b76fd527ed0fa5aa1d28652838bcab4ee4ee63197446973636f696e": {
    token_id: "5612bee388219c1b76fd527ed0fa5aa1d28652838bcab4ee4ee63197446973636f696e",
    token_policy: "5612bee388219c1b76fd527ed0fa5aa1d28652838bcab4ee4ee63197",
    token_ascii: "discoin",
    is_verified: !0,
    ticker: "DISCO"
  },
  "4f9f1653cd6fc1bbcd2f5512d5c92bfacd5573455c56723cf029beb6434152524f5453": {
    token_id: "4f9f1653cd6fc1bbcd2f5512d5c92bfacd5573455c56723cf029beb6434152524f5453",
    token_policy: "4f9f1653cd6fc1bbcd2f5512d5c92bfacd5573455c56723cf029beb6",
    token_ascii: "CARROTS",
    is_verified: !0,
    ticker: "CARROTS"
  },
  "0a0a43129b17470da7b60dcbbeb5a7c2007fe58bd64440dbbe5f7731756e697665727365": {
    token_id: "0a0a43129b17470da7b60dcbbeb5a7c2007fe58bd64440dbbe5f7731756e697665727365",
    token_policy: "0a0a43129b17470da7b60dcbbeb5a7c2007fe58bd64440dbbe5f7731",
    token_ascii: "ONE",
    is_verified: !0,
    ticker: "ONE"
  },
  "8e51398904a5d3fc129fbf4f1589701de23c7824d5c90fdb9490e15a434841524c4933": {
    token_id: "8e51398904a5d3fc129fbf4f1589701de23c7824d5c90fdb9490e15a434841524c4933",
    token_policy: "8e51398904a5d3fc129fbf4f1589701de23c7824d5c90fdb9490e15a",
    token_ascii: "CHARLI3",
    is_verified: !0,
    ticker: "C3"
  },
  "905da53004cfee0b8549285949aebedf82b5c6bb9a412cbd9658c6de434343": {
    token_id: "905da53004cfee0b8549285949aebedf82b5c6bb9a412cbd9658c6de434343",
    token_policy: "905da53004cfee0b8549285949aebedf82b5c6bb9a412cbd9658c6de",
    token_ascii: "Crypto College Coin",
    is_verified: !0,
    ticker: "CCC"
  },
  "6f0d19b97761a48b53438e926c63a2a75ec1aaa3f763a4f7070c258942524557": {
    token_id: "6f0d19b97761a48b53438e926c63a2a75ec1aaa3f763a4f7070c258942524557",
    token_policy: "6f0d19b97761a48b53438e926c63a2a75ec1aaa3f763a4f7070c2589",
    token_ascii: "Fudbrew",
    is_verified: !0,
    ticker: "$BREW"
  },
  d5dec6074942b36b50975294fd801f7f28c907476b1ecc1b57c916ed524154: {
    token_id: "d5dec6074942b36b50975294fd801f7f28c907476b1ecc1b57c916ed524154",
    token_policy: "d5dec6074942b36b50975294fd801f7f28c907476b1ecc1b57c916ed",
    token_ascii: "RAT",
    is_verified: !0,
    ticker: "RAT"
  },
  "782c158a98aed3aa676d9c85117525dcf3acc5506a30a8d87369fbcb4d6f6e6574": {
    token_id: "782c158a98aed3aa676d9c85117525dcf3acc5506a30a8d87369fbcb4d6f6e6574",
    token_policy: "782c158a98aed3aa676d9c85117525dcf3acc5506a30a8d87369fbcb",
    token_ascii: "Monet",
    is_verified: !0,
    ticker: "MONET"
  },
  "1ddcb9c9de95361565392c5bdff64767492d61a96166cb16094e54be4f5054": {
    token_id: "1ddcb9c9de95361565392c5bdff64767492d61a96166cb16094e54be4f5054",
    token_policy: "1ddcb9c9de95361565392c5bdff64767492d61a96166cb16094e54be",
    token_ascii: "OptionFlowToken",
    is_verified: !0,
    ticker: "OPT"
  },
  "3fc6548aed99326821131fc480ec65a03d01efe92f58978e24ab8e795445434b454c": {
    token_id: "3fc6548aed99326821131fc480ec65a03d01efe92f58978e24ab8e795445434b454c",
    token_policy: "3fc6548aed99326821131fc480ec65a03d01efe92f58978e24ab8e79",
    token_ascii: "Teckel",
    is_verified: !1,
    ticker: "TECKEL"
  },
  "5b01968867e13432afaa2f814e1d15e332d6cd0aa77e350972b0967d476f76546f6b656e": {
    token_id: "5b01968867e13432afaa2f814e1d15e332d6cd0aa77e350972b0967d476f76546f6b656e",
    token_policy: "5b01968867e13432afaa2f814e1d15e332d6cd0aa77e350972b0967d",
    token_ascii: "GovToken",
    is_verified: !0,
    ticker: "TADAO"
  },
  da8c30857834c6ae7203935b89278c532b3995245295456f993e1d244c51: {
    token_id: "da8c30857834c6ae7203935b89278c532b3995245295456f993e1d244c51",
    token_policy: "da8c30857834c6ae7203935b89278c532b3995245295456f993e1d24",
    token_ascii: "Liqwid DAO Token",
    is_verified: !0,
    ticker: "LQ"
  },
  "358e87af871fa88479b5e07f1744e2f866831f43a779e696ef945ee74d4548": {
    token_id: "358e87af871fa88479b5e07f1744e2f866831f43a779e696ef945ee74d4548",
    token_policy: "358e87af871fa88479b5e07f1744e2f866831f43a779e696ef945ee7",
    token_ascii: "MEH COIN",
    is_verified: !0,
    ticker: "MEH"
  },
  "9d9ffb66370242f89e75cbed564d2d7b9b08eab35d9cc2ab5e25a844424c4f434b": {
    token_id: "9d9ffb66370242f89e75cbed564d2d7b9b08eab35d9cc2ab5e25a844424c4f434b",
    token_policy: "9d9ffb66370242f89e75cbed564d2d7b9b08eab35d9cc2ab5e25a844",
    token_ascii: "BLOCK",
    is_verified: !0,
    ticker: "BLOCK"
  },
  "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c4469676974616c4b617368": {
    token_id: "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c4469676974616c4b617368",
    token_policy: "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c",
    token_ascii: "Digitalkash",
    is_verified: !0,
    ticker: "aDKASH"
  },
  "586c476d22fdff736e0b399485eb9fb9803a941b0b676f1b4c8d7c4345444f54": {
    token_id: "586c476d22fdff736e0b399485eb9fb9803a941b0b676f1b4c8d7c4345444f54",
    token_policy: "586c476d22fdff736e0b399485eb9fb9803a941b0b676f1b4c8d7c43",
    token_ascii: "EDOT",
    is_verified: !0,
    ticker: "EDOT"
  },
  "9ff14600a3fdaee6da3b1e3d227e2235d1fad199c3691ba2c7d8665a4d415253": {
    token_id: "9ff14600a3fdaee6da3b1e3d227e2235d1fad199c3691ba2c7d8665a4d415253",
    token_policy: "9ff14600a3fdaee6da3b1e3d227e2235d1fad199c3691ba2c7d8665a",
    token_ascii: "MARS",
    is_verified: !0,
    ticker: "MARS"
  }
}, a = {
  ada: "000000000000000000000000000000000000000000000000000000006c6f76656c616365",
  fact: "a3931691f5c4e65d01c429e473d0dd24c51afdb6daf88e632a6c1e516f7263666178746f6b656e",
  tuna: "279f842c33eed9054b9e3c70cd6a3b32298259c24b78b895cb41d91a54554e41",
  konda: "501dd5d2fbab6af0a26b1421076ff3afc4d5a34d6b3f9694571116ea4b4f4e4441",
  $aduh: "12274673b36fa1507084eae4b9f78d28bd67266396331f46528c397441445548",
  edot: "586c476d22fdff736e0b399485eb9fb9803a941b0b676f1b4c8d7c4345444f54",
  vnm: "2d92af60ee429bce238d3fd9f2531b45457301d74dad1bcf3f9d1dca564e4d",
  mutant: "ffb1abe9fe93ee9f13874403a3d4f8addaa65fbf22d5d7f41c087d8e4d5554414e54",
  che: "f0451f9d13eb8e7c9be861a675d00cc4e0e174f527757b772c4dff18434845",
  cneta: "b34b3ea80060ace9427bda98690a73d33840e27aaa8d6edb7f0c757a634e455441",
  bcg: "0c92aabef5a8f91a36470d0762806c165c0d04aa992541e25d55486a424347",
  troll: "6a078f51d4a343c5f9022ebe2fa88975a18cbd58442cb1021a1b900c54524f4c4c",
  prspr: "52489ea87bbceaf6375cc22f74c19382a3d5da3f8b9b15d2537044b95052535052",
  addax: "4a2e215bced3fd8ccc3edec108347d9f8984ef82bac8c8903f02d1b04144444158",
  bread: "3f2880d10da4c8567ffc1f705b4b526c331ed2e875c63c4b68aff5804252454144",
  mnt: "43b07d4037f0d75ee10f9863097463fc02ff3c0b8b705ae61d9c75bf4d796e746820546f6b656e",
  revu: "94cbb4fcbcaa2975779f273b263eb3b5f24a9951e446d6dc4c13586452455655",
  derp: "961f2cac0bb1967d74691af179350c1e1062c7298d1f7be1e4696e312444455250",
  kidz: "c4c00fbd8fa227442a5e7cdecde33b24588494d05a2c50fda8938c6d4b49445a",
  lizo: "e3334680040528178a13026dee65a620be396d4a34b25a524c653af14c495a4f",
  rad: "6787a47e9f73efe4002d763337140da27afa8eb9a39413d2c39d4286524144546f6b656e73",
  $purr: "d3a034e403b98cbdb0adbc8a3144d7779330916e190d387815bb85c650555252",
  indy: "533bb94a8850ee3ccbe483106489399112b74c905342cb1792a797a0494e4459",
  ginko: "401f734390bb03578000c28b7c69d818fce14de3caed59c8aaec08ff47494e4b4f",
  rum: "7bf18ff8bbc7cd4adbf4a31828fc3ada26fe40f52de27394ec36b03e4f544b2052756d",
  wesp: "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c457370657273",
  hydrgms: "43a078846ae28140f5a5c2714ffcc689555d7e0efcfcaf79ce2910fa487964726147616d6573",
  jfuel: "376b46d7abe9a2a8d9d6dfa8f1979c41bc4251f02bbd7bc58acf3e704a6675656c",
  dnb: "9d093d73d273ff6456e85bcd9c524fa18fedb0f0274e41d7344a57b4444f4e4f54425559",
  bukele: "0c002b51df1a54194819c0990f52d14682bbb3e93a58052e7c81f71c42554b454c45",
  sick: "ad1c1ed3a0bb6f83630ef052a31b71ba3287bf4bafa8370758f14d315349434b5349434b",
  kube: "a26022096c6a8052987dabbfa94849ab7886cf0bb7840044e017d5be4b756265436f696e",
  rune: "c9281d64953f9531304e57e4ff15111f0c5445167c0b413f70fcd50c52554e45",
  cp: "92292852e3820cfbe99874b284fdf2befbddb38e070cf3512009a60a436f6c6f72506561726c",
  zro: "41a806e6cc38741eb81cc68f6300ee37df0c10b6b99dcb251aa82c3b5a5230",
  snek: "279c909f348e533da5808898f87f9a14bb2c3dfbbacccd631d927a3f534e454b",
  salzy: "eb2fb0975dbd8d4b439eef8f252dbbf7dea998e58186b6a74b5431b353414c5a59",
  mithr: "65bdf33f8f7fd4debeb2ad659473749eb4eac177e06650bb75a8fe504d69746872546f6b656e",
  woz: "32bc130691066340caf48ef53d52c684a0e497ffc935d2fd6741efe0574f5a",
  saelem: "e1ed70ad8423bc63ac1287f2329c9380528284894dd4cbe70a5c722d5341454c454d",
  ctv: "9f452e23804df3040b352b478039357b506ad3b50d2ce0d7cbd5f806435456",
  froggie: "79906b9c8d2fbddeba9658387a2a1187f3edd8f546e5dc49225710a146524f47474945",
  drip: "af2e27f580f7f08e93190a81f72462f153026d06450924726645891b44524950",
  deg: "473e6a5a73108783abdd8b540eb0bca7265741d1f1e8fa55b0e8ef32646567656e",
  cetf: "02a4e5d69c39dc69ca5673836545743f425563965af06fe002bdd79043455446",
  iusd: "f66d78b4a3cb3d37afa0ec36461e51ecbde00f26c8f0a68f94b6988069555344",
  kita: "6767df9b642eb1252ceb2d469a85b93889eae2790acd788ea31fa0834b495441",
  round: "3682715f97086e72ff37a7e6759a5ff0b44c98296afc2b407debe52b524f554e44",
  rasta: "50009ca6291a2d1069bfb8d01dd2776401fe5d767f603b6cee55ab015241535441",
  qai: "354a6c0acd846b195768ead31c92693ad26d82ba013e7df5d9777081514149",
  teckel: "3fc6548aed99326821131fc480ec65a03d01efe92f58978e24ab8e795445434b454c",
  proxie: "20cd68533b47565f3c61efb39c30fdace9963bfa4c0060b613448e3c50524f584945",
  c4: "a00fdf4fb9ab6c8c2bd1533a2f14855edf12aed5ecbf96d4b5f5b9394334",
  ctosi: "a8a1dccea2e378081f2d500d98d022dd3c0bd77afd9dbc7b55a9d21b63544f534920",
  ding: "ce5b9e0f8a88255b65f2e4d065c6e716e9fa9a8a86dfb86423dd1ac044494e47",
  dslvr: "59515c449f1ec1d21a4b2d93013337d13b29d74c3a665a11d5b7fc6644534c5652",
  "": "21abdf54f427b378fe9ba07419eff6e8e8fe0c5932e1fee2d3853b9350455045424c5545",
  myst: "d01794c4604f3c0e544c537bb1f4268c0e81f45880c00c09ebe4b4a74d595354",
  superpeso: "9b199c2d7d2f8fe66c8da8b843380c2228d3e92aee64a3ee81d9d50453757065725065736f",
  cmc: "a56b1bfd69d317076c5c864d647851e2961594b21ec056f3c84914856473636e",
  mingo: "7536b72f0d1f84c7935fc3b4471032ad4ca33b92974d0a3fe7e03e514d494e474f",
  pbx: "cc8d1b026353022abbfcc2e1e71159f9e308d9c6e905ac1db24c7fb650617269627573",
  wfrog: "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c46726f67436f696e",
  fda: "057e283baef26fe8879f0a5b56d55893507cee6933c85babcb8db216464441",
  hosky: "a0028f350aaabe0545fdcb56b039bfb08e4bb4d8c4d7c3c7d481c235484f534b59",
  zalgo: "4a50a3c79cd9365b8eb10e257865f93f0e05d79004b409956fdcb3a85a414c474f",
  chrlz: "e9c28a71273f825b13f38244ccf1fea97c4025813610d01a7c5d681f436861726c7a20546f6b656e",
  flesh: "a1ce0414d79b040f986f3bcd187a7563fd26662390dece6b12262b52464c45534820544f4b454e",
  adalot: "e6f464202e7c89befd79fdd3905ca96c896772721485dff66fd6b2d24144414c4f54",
  cap: "6a659a86a0f35825bb9b0724ee70bc6a090e5910e1423a86a48cc955434150",
  stable: "2adf188218a66847024664f4f63939577627a56c090f679fe366c5ee535441424c45",
  audit: "f2fe9aafd2e5b3b00e2949a96d44a84d9f4d818d63945010a466a4ae4155444954",
  cyclr: "e8e6b35d977a56ae5a221786eb0b2b348b8555e6e6afc6a54c25d2c54379636c72",
  xray: "86abe45be4d8fb2e8f28e8047d17d0ba5592f2a6c8c452fc88c2c14358524159",
  iag: "5d16cc1a177b5d9ba9cfa9793b07e60f1fb70fea1f8aef064415d114494147",
  fxd: "a1fb1a8f55298d54133e96c8edba68244ef14d9e27272bf9b9643e0a465844",
  strip: "6954264b15bc92d6d592febeac84f14645e1ed46ca5ebb9acdb5c15f5354524950",
  snepe: "b3bd74dd43f83815519e387bdffd1cb9be411df8f2774f48e0fd3669534e455045",
  agix: "f43a62fdc3965df486de8a0d32fe800963589c41b38946602a0dc53541474958",
  risk: "2274b1699f5398170e0497598de7877ebb370ba7b5d25a1d0b2fea075249534b",
  cherry: "e14fe3ab348f9a6198359481472601f4557b9f86984f40a186a3b1e8434845525259",
  baby: "389224fd2601bc0d9fcf546430956d8d61b0dc911d6f41d57ccaf7e742414259",
  mayz: "9e975c76508686eb2d57985dbaea7e3843767a31b4dcf4e99e5646834d41595a",
  panda: "8d7cc34c1a44ef419cf1560cbb84e7720ca6c03ab99f8745ab61d19d50414e4441",
  world: "9c2a02b3a38380568749ff510a27d8884bd689dd6acbe2acfee4a509576f726c64",
  elv: "faf9889f47c0b39177a7e07fe71ee5f5037beb01dcec3d4f2daae586456c657661746f72204c616273",
  whale: "e71a541df41dd14269bc63d40fb02bc91a3c3d344605948d173d88145748414c45",
  amonkey: "98986c9f88fbe01cb16af3fb85dcca5c876b5eff68aaa1d5e785b2756d6f6e6b6579",
  catsky: "9b426921a21f54600711da0be1a12b026703a9bd8eb9848d08c9d921434154534b59",
  blues: "e043fd7b2076ea9e1b279d200b59e153bf6b299a72ce6e2c14aeb790424c554553",
  rk: "1e54cf3b5832978582ac3baade392fa09a52dbd588dae1a403c4d72c52554d41484b495441",
  eladr: "2d420236ffaada336c21e3f4520b799f6e246d8618f2fc89a4907da64564756c6164646572546f6b656e",
  myield: "8f9c32977d2bacb87836b64f7811e99734c6368373958da20172afba4d5949454c44",
  ron: "b201928d6bdb21c2e39205a92e226653d6002b949eaaacde3d986c2f524f4e",
  eternal: "86b116d8cfd880445825208b4a355b7715b63763d6d8f3d37338d211657465726e616c",
  htph: "c4c497a70541172b39be5d30c89e07a047b0a75b17adbf41927a5c9748545048",
  dump: "ddeec4b6d0c03b6ba4c6135e8e81031748554a5626c23363878f53dd44554d50",
  dino: "85d87212f6096732ac1cdbf604a12aa8cfd1fd0b66ab28fc77d3764c44494e4f",
  gensx: "fbae99b8679369079a7f6f0da14a2cf1c2d6bfd3afdf3a96a64ab67a0014df1047454e5358",
  dumb: "c50e06eb7d36ce67af2b15dd38228b59e39a5dae644166c84e3d2d1344554d42",
  mvoucher: "a2936e00439913f1ac105c29883c013322360247c409343028b831be4d564f5543484552",
  fud: "dbc31b04d90b37332813cb4cee3e8f79994643d899a5366797e745ee465544",
  vyfi: "804f5544c1962a40546827cab750a88404dc7108c0f588b72964754f56594649",
  kc: "1111170eb2f1fc2eaf1ea6503c0160eda20de2a84418f988720a7c8e4b525950544f",
  tang: "bf9354cba4ee83c5de05c72830c6430967a26a1656b06293541d23e154414e47",
  bot: "da247e71f71b0195c8188bf43827f34c9357cc388fceed596d100d95424f54",
  madbl: "ea2d23f1fa631b414252824c153f2d6ba833506477a929770a4dd9c24d414442554c",
  jpg: "681b5d0383ac3b457e1bcc453223c90ccef26b234328f45fa10fd2764a5047",
  token: "0171c997b8853fde686763d93b36ab8e04ce947bb6aa09a9ee5c4401544f4b454e",
  kani: "f01ec1cb021922a491ea300fb4791dbaca720372b2a3142579c52e7d4b616e69",
  peace: "7192cee89b2cd731152e60de5fd849f3930c24ac97f6daca09b54cf35065616365",
  harm: "b38d94e35b3e638dce7e5e0b0aeebcbe06987a118b46d3d4c042c8c26861726d6c657373636f696e",
  shh: "ddbca1e3ee9849c439e13c2cc3daebea6ad17a04df11bc0aad3b76ae534848",
  hydra: "c8764cd53485b29f6ad94bf69f399ac72903b4df1e70d6a119d6596e4859445241",
  bp: "92292852e3820cfbe99874b284fdf2befbddb38e070cf3512009a60a426c61636b506561726c",
  hunt: "95a427e384527065f2f8946f5e86320d0117839a5e98ea2c0b55fb0048554e54",
  samu: "4632693c8a8ab3e325391bf319d69c24c54b823d70a85d870197fd3853414d55",
  wari: "462d81b809c4cbc9039a536a6139393d640e3f54c563c0404ef92a5f57415249",
  wild: "50861cf745ea40fb79024380fa3b642152a47cb3acae2778a517f16357494c44",
  end: "5e607fcf4933ae7a713a4d190ace86832c67e610eab8c27f71ae746a456e64",
  ladyc: "c30190b33eff1af6566201bed3400676d8a8e61ebb3180c14e90734e4d494c41445943",
  gnug: "dc280dbb5381ef28afbab4ca31751f13c29562d376998e907ff1af32474e5547",
  pada: "c5f87616092bc2595960b3f87c8760703cc5afb87b3a025d9ae6f70470414441",
  beam: "b1a80ea5d4b5c9f8d550fb9fa9fe53433903f420a449c8977b3470fa4245414d",
  mcos: "6f46e1304b16d884c85c62fb0eef35028facdc41aaa0fd319a152ed64d434f53",
  society: "25f0fc240e91bd95dcdaebd2ba7713fc5168ac77234a3d79449fc20c534f4349455459",
  soc: "25f0fc240e91bd95dcdaebd2ba7713fc5168ac77234a3d79449fc20c534f4349455459",
  dgada: "b4273f1d8d0021d188784c3d72dc514f602b7ab8cfb87e3134550c42446f6765414441",
  rjv: "8cfd6893f5f6c1cc954cec1a0a1460841b74da6e7803820dde62bb78524a56",
  meld: "6ac8ef33b510ec004fe11585f7c5a9f0c07f0c23428ab4f29c1d7d104d454c44",
  newm: "682fe60c9918842b3323c43b5144bc3d52a23bd2fb81345560d73f634e45574d",
  virus: "0fd9819a9d7fb414880883f43a42d33458f12bc5f9841cec6457dc155669527553",
  min: "29d222ce763455e3d7a09a665ce554f00ac89d2e99a1a83d267170c64d494e",
  wrt: "c0ee29a85b13209423b10447d3c2e6a50641a15c57770e27cb9d507357696e67526964657273",
  pugchip: "5ec2e9813fa385d9333d18186d8257d1b3ebea97bdec2dad74026d8d50554743484950",
  nfa: "9f144f7c7c9e656f905c09442e08376dbb6ee0ef80dd8afe0a4fc07347726f6f7065657a546f6b656e",
  rhod: "a5039068cb2b3ebcf874c0a4b012f19409befcf99e38c34c080af9d552686f6469756d436f696e",
  tv: "efa0e694d5915f52b00a0d01135efdb85a0bdde7009bbcf68ea12a3d5456",
  coto: "24a87872afa67f8860b7f6e910a63ddaffe39ed3a8affb04981eeaa9434f544f",
  ibtc: "f66d78b4a3cb3d37afa0ec36461e51ecbde00f26c8f0a68f94b6988069425443",
  cerra: "4342a3d3c15545a592bf38294dc75c7a1dd3550388303e3a06f4416d4345525241",
  mira: "160a880d9fc45380737cb7e57ff859763230aab28b3ef6a84007bfcc4d495241",
  pudgy: "133fac9e153194428eb0919be39837b42b9e977fc7298f3ff1b76ef95055444759",
  wyrm: "4ffaa4ef3217df37c4995bb96066af4cb68dfcc66b9f2a10e0c333b95779726d73746f6e65",
  bubble: "4fde92c2f6dbcfa2879b44f7453872b31394cfb2f70f1d4c411169ac427562626c65",
  adao: "5b01968867e13432afaa2f814e1d15e332d6cd0aa77e350972b0967d4144414f476f7665726e616e6365546f6b656e",
  hyc: "6ded36273214629f9ff35e9f9c7b8945d937a80a3796ddc4a646a50e485943",
  wmt: "1d7f33bd23d85e1a25d87d86fac4f199c3197a2f7afeb662a0f34e1e776f726c646d6f62696c65746f6b656e",
  ngmi: "95b1962fbb6c42c1a16a3ac60459806e7ee7dba4f845e4498082524f4e474d49",
  pavia: "884892bcdc360bcef87d6b3f806e7f9cd5ac30d999d49970e7a903ae5041564941",
  love: "7192cee89b2cd731152e60de5fd849f3930c24ac97f6daca09b54cf34c6f7665",
  fet: "815418a1b078a259e678ecccc9d7eac7648d10b88f6f75ce2db8a25a4672616374696f6e2045737461746520546f6b656e",
  encs: "9abf0afd2f236a19f2842d502d0450cbcd9c79f123a9708f96fd9b96454e4353",
  apecash: "cfbc6b8519f252b1f1694cdbb9df9f339b343bdd0f2079d84e4afdd941504543415348",
  shark: "23ac1afe924ebbc002cbc7afdf22f09a9ea8fb8bddd3b20398be71c2534841524b",
  cpiggy: "0c3b14ddb319c5a50bfd93e69d0706d1527e2b2169744665a1c534d0635049474759",
  pmx: "8499f3958a114d03b6289185138a60378951a2b5491cb2a080ff7b6e504d58",
  eus: "88691a70bb0fe49cf9124b4f78553c36c09fa6264844e2b2941191734575736b6f",
  $cast: "cdaaee586376139ee8c3cc4061623968810d177ca5c300afb890b48a43415354",
  $lobster: "8654e8b350e298c80d2451beb5ed80fc9eee9f38ce6b039fb8706bc34c4f4253544552",
  ww: "521ec1ae6f87ec944a4b32890d62cd4a243d612f80fe26db999628f05757",
  ddos: "2c85a478d53f0e484b852c357e56057dfd8e80a6b72ecb4daffe42e544444f53",
  ninjaz: "df1d850c46d6c9d12cbf6181c35db9225a91b77c8a646b7f636f8ae40014df104e494e4a415a",
  md: "772791eb3f4b92874a49d487375a90db631988291c1a643b817668ca4d616420446f6720546f6b656e",
  djed: "8db269c3ec630e06ae29f74bc39edd1f87c819f1056206e879a1cd61446a65644d6963726f555344",
  lexy: "d244fcb1d038951eb4fcdba0cc77299453ec96d18ac786ccd284cc784c657879",
  cblp: "ee0633e757fdd1423220f43688c74678abde1cead7ce265ba8a24fcd43424c50",
  cd: "fed1c459a47cbff56bd7d29c2dde0de3e9bd15cee02b98622fce82f743617264616e6f436f70706572",
  king: "2edc63d29e94747f7ef65df559260c994d2ecfe208ac6afa564517384b494e47",
  chroma: "4d8469c80677574a5dd23b0fdd0eb0057fb6ce4e20cf21c7e8655f954348524f4d41",
  mint: "29d222ce763455e3d7a09a665ce554f00ac89d2e99a1a83d267170c64d494e74",
  money: "322490202fbfba723c837c54695d80b61c79ed39dee31dd492391f4b4d6f6e6579",
  gero: "10a49b996e2402269af553a8a96fb8eb90d79e9eca79e2b4223057b64745524f",
  apx: "4f771973824f79fff176fe5cc0f29f5f5331a4692e5aa9a0bd0cdde6415058",
  awoo: "09f5f55fcad17503e6b7acc81de7c80f84b76e76d17085f0e32f1ce22d6d2041574f4f0a",
  yummi: "078eafce5cd7edafdf63900edef2c1ea759e77f30ca81d6bbdeec92479756d6d69",
  bd: "c79a25118b06dddc9094a547dd534046ddf9efde264ae1ab9cdf777642756c6c79",
  cswap: "bf524874448cbf52be3a26133b0a0edf5eb65c09ffed383b881ad3274353574150",
  rocket: "c490a79c6afd84c5e5dfe487a5fe8b6009c239befff69745c43711ef524f434b4554",
  arf: "d1407478fb3151f60fc533cd42d806dd7115cecfa25a018baf53c4dc415246",
  lenfi: "8fef2d34078659493ce161a6c7fba4b56afefa8535296a5743f6958741414441",
  emp: "6c8642400e8437f737eb86df0fc8a8437c760f48592b1ba8f5767e81456d706f7761",
  fire: "a4da8764a57e66a0085b5bfcde96c89b798d92ee83a75f59237e375b46495245",
  greens: "4623ab311b7d982d8d26fcbe1a9439ca56661aafcdcd8d8a0ef31fd6475245454e53",
  shen: "8db269c3ec630e06ae29f74bc39edd1f87c819f1056206e879a1cd615368656e4d6963726f555344",
  gp: "92292852e3820cfbe99874b284fdf2befbddb38e070cf3512009a60a47726179506561726c",
  ntx: "edfd7a1d77bcb8b884c474bdc92a16002d1fb720e454fa6e993444794e5458",
  galaxy: "755a497e592fb6a20337d19d86e1da82d27282db5c9083e0ddaa338c47414c415859",
  coon: "fccb53cf9d12b07a148c40b349c857bfe2b413cef5cbcf5e6afe7351434f4f4e",
  cblue: "74be1f6940dadc4ab85c643d7447b45cf4e1b5e9cfd5fed062e903f863617264616e6f2e626c7565",
  smokes: "23690795536ccf407ed6eeac57db98db9668b3a026991fb516ecd7ef0014df10534d4f4b4553",
  moai: "482fb00dc32186a4c587dca2df3c7cf2bc455332ab581d51967306e14d4f4149",
  invada: "c448753e6dac6d4d3508e47f636122c715e3c8575955ae77307b305f696e76616461",
  charly: "89267e9a35153a419e1b8ffa23e511ac39ea4e3b00452e9d500f2982436176616c6965724b696e67436861726c6573",
  sundae: "9a9693a9a37912a5097918f97918d15240c92ab729a0b7c4aa144d7753554e444145",
  dgaf: "64c3ebd40ed377989aa3069a2936e07c6ce82df46688c473d921520664676166",
  rag: "ca942cb8bb5d1ef750766ded355f320880539111f10efa2b1a478ff9524147",
  forge: "0fc1a2c01b3b96e6fc18681852c26d904b4ca180150671e1b250369f464f524745",
  bepc: "4756b1e7626e84c6de4fe4256b874412c5529a8e75b707ba1e677f4642455043",
  fxi: "454669a208d486fe98c6eca9070c62df7fc8449d1bf6237a5fe1aa11465849",
  peepee: "07ccfad78099fef727bfc64de1cf2e684c0872aab3c3bb3bed5e1081706565706565",
  puw: "87a59599f8f47db431de642329a275cd4b297f21f1517af9db442cee506f705570576f726c64",
  work: "bbd0ec94cf9ccc1407b3dbc66bfbbff82ea49718ae4e3dceb817125f24574f524b",
  raker: "ace2ea0fe142a3687acf86f55bcded860a920864163ee0d3dda8b60252414b4552",
  bank: "2b28c81dbba6d67e4b5a997c6be1212cba9d60d33f82444ab8b1f21842414e4b",
  copi: "b6a7467ea1deb012808ef4e87b5ff371e85f7142d7b356a40d9b42a0436f726e75636f70696173205b76696120436861696e506f72742e696f5d",
  clap: "db30c7905f598ed0154de14f970de0f61f0cb3943ed82c891968480a434c4150",
  butter: "8be741cb809416f0785837d00a0fba01de42e3580d96e378f82b24ab427574746572",
  geck: "7e4f764cd4283d99b2bbf532d80e8105c3ae58a21b089bce8068170b4745434b",
  util: "0d90046ad35546156aaf790525133f7fc713ca2790e397784b85f5c85554494c",
  clay: "38ad9dc3aec6a2f38e220142b9aa6ade63ebe71f65e7cc2b7d8a8535434c4159",
  skull: "885742cd7e0dad321622b5d3ad186797bd50c44cbde8b48be1583fbd534b554c4c",
  milk: "8a1cfae21368b8bebbbed9800fec304e95cce39a2a57dc35e2e3ebaa4d494c4b",
  wojakblue: "a1b284d7218dd63772c67ca26ab73721a196b404929cddef595f9967574f4a414b424c5545",
  trtl: "52162581184a457fad70470161179c5766f00237d4b67e0f1df1b4e65452544c",
  ath: "5acc52d5696e52345aec108468050d9d743eb21d6e41305bbc23a27b4154484f4d",
  bfd: "1b99120f61cd9c30938661b5144a352857431a14b2334faef8a180c7424644526f636b6574436f696e",
  danzo: "c69b36d2939ca42bf3d8c1dae2bfed9e8a4c34dc3f002ff3782227c044414e5a4f",
  yeti: "96abe9a17b65c2133ed7e11864338e965efc418c0961ceecfac1617259455449",
  nmkr: "5dac8536653edc12f6f5e1045d8164b9f59998d3bdc300fc928434894e4d4b52",
  wp: "92292852e3820cfbe99874b284fdf2befbddb38e070cf3512009a60a5768697465506561726c",
  dd: "e88e1e4d7e5c807a4c325d7d7d6bba98eaa4d53c2b8c0ff5ae5187326444",
  cfc: "71ccb467ef856b242753ca53ade36cd1f8d9abb33fdfa7d1ff89cda3434643",
  ieth: "f66d78b4a3cb3d37afa0ec36461e51ecbde00f26c8f0a68f94b6988069455448",
  vada: "94a21344f388a259dc8b1f3bcf91d9439379dd748b18a7168ed0b35976414441",
  gens: "dda5fdb1002f7389b33e036b6afee82a8189becb6cba852e8b79b4fb0014df1047454e53",
  cbtc: "4190b2941d9be04acc69c39739bd5acc66d60ccab480d8e20bc87e3763425443",
  ded: "7ced2090df97de4a4c25a6be62a916cfdd4ad794a828fbb743b2d56e444544",
  crdo: "eef4f770d16d2d4c09f0eae47eec8a6c13244d772f45ee41fc822c944352444f",
  chry: "75fcc276057db5fc48eae0e11453c773c8a54604c3086bf9d95ac1b743485259",
  idp: "b9168f05e657b6946fede254e383586cf7e7a2573d5a0fa12b3ef6ac494450",
  zombie: "88c7fe7cf68625fd24dc3405432684ae85da094dceff25f81d6664fd5a4f4d424945",
  ptc: "007394e3117755fbb0558b93c54ce3bc6c85770920044ade143dc742505443",
  dgold: "16fdd33c86af604e837ae57d79d5f0f1156406086db5f16afb3fcf5144474f4c44",
  qts: "9d86482511c8a49f21d5c83ee58a49e2926f70ac57dd73ed204042697175657374",
  lifi: "7914fae20eb2903ed6fd5021a415c1bd2626b64a2d86a304cb40ff5e4c494649",
  salty: "07f019ce45fb638353258bda4316ce5eb3d0f76a3fb739c45174084953414c5459",
  ady: "438514ae1beb020d35e5389993447cea29637d6272c918017988ef364164615969656c64",
  kekw: "3ee8e0824a7a81bdc5bcacd004c25d3264dd8ac3eb4ab877b5d7d0ce6b656b77",
  osm: "37a2b93b4aa2b286b92b7099faff0bb87e0c629a5079c0584da2d5774f534d",
  spf: "09f2d4e4a5c3662f4c1e6a7d9600e9605279dbdcedb22d4507cb6e75535046",
  ashib: "afc910d7a306d20c12903979d4935ae4307241d03245743548e767834153484942",
  wppcn: "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c50757061436f696e",
  zoo: "15637826ecbdb4e5747fd41f830d9735a8c4e6d927e44d29ceef9e885a4f4f",
  nftc: "b0af30edf2c7f11465853821137e0a6ebc395cab71ee39c24127ffb44e465443",
  mka: "f4d97191f857096b441a410c036f63d6697dde0c71d2755dd664e3024d4b41",
  wdimi: "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c44696d696e7574697665436f696e",
  mtc: "f6ac48c64aa7af16434d9f84e014d11fba38525b436acc338ff20b0d4d7463",
  snow: "8f52f6a88acf6127bc4758a16b6047afc4da7887feae121ec217b75a534e4f57",
  iamx: "12d5f4fefe222d52a4fdcee56f4b272911d7c2202b068a08ebf5327049414d58",
  flac: "8daefa391220bd0d8d007f3748d870f7f3c106040314c8515ccc35a5464c4143",
  blc: "585cfcbdd0786e961187999e5d5d36b38d1ebc1c4112a0a95a8bd477424c43",
  cargo: "f4364875e75320d405ceadebdf0db63fadaff55c72d4ff6b82f0676a434152474f",
  herb: "bb4cfbe0f6be60b80f90f815e8353b93431de4df785d75350b9d214a48455242",
  wolf: "1a71dc14baa0b4fcfb34464adc6656d0e562571e2ac1bc990c9ce5f6574f4c46",
  vyra: "493136618a39dcefb89ff573061f715ee32e88092d0299c54e3a377356595241",
  idol: "fce30a7f7d16e48c69a7847ec908fe098a0efa0dbc99bad8e2aec15a69646f6c",
  $garycbdc: "6106ab6d8912a8f7e08b5d3300d5f8bdd6371793caceee7e0859868547617279546865436c6f776e",
  cccc: "ab3e31c490d248c592d5bb495823a45fd10f9c8e4f561f13551803fb43617264616e6f20436f6d6d756e697479204368617269747920436f696e",
  crack: "ee7ffc3c9402a4b75de30574d631546492bb4a448cc8966fd994ba30435241434b",
  $stinky: "6d03347cbf9d02ace480933170b190844f61ead0477c0bd0e53bb4dd5354494e4b59",
  sweet: "47959e79846b8bdcacb91f586408d97e2dff44f31a04f03902cba8185357454554",
  gokey: "c7dcfa416c127f630b263c7e0fe0564430cfa9c56bba43e1a37c6915474f4b4559",
  dean: "fb0e9a083ac66c814548002cbdfc54557e064e4cdf5c6675e72d22b44445414e",
  aduh: "12274673b36fa1507084eae4b9f78d28bd67266396331f46528c397461647568",
  disco: "5612bee388219c1b76fd527ed0fa5aa1d28652838bcab4ee4ee63197446973636f696e",
  carrots: "4f9f1653cd6fc1bbcd2f5512d5c92bfacd5573455c56723cf029beb6434152524f5453",
  one: "0a0a43129b17470da7b60dcbbeb5a7c2007fe58bd64440dbbe5f7731756e697665727365",
  c3: "8e51398904a5d3fc129fbf4f1589701de23c7824d5c90fdb9490e15a434841524c4933",
  ccc: "905da53004cfee0b8549285949aebedf82b5c6bb9a412cbd9658c6de434343",
  $brew: "6f0d19b97761a48b53438e926c63a2a75ec1aaa3f763a4f7070c258942524557",
  rat: "d5dec6074942b36b50975294fd801f7f28c907476b1ecc1b57c916ed524154",
  monet: "782c158a98aed3aa676d9c85117525dcf3acc5506a30a8d87369fbcb4d6f6e6574",
  opt: "1ddcb9c9de95361565392c5bdff64767492d61a96166cb16094e54be4f5054",
  tadao: "5b01968867e13432afaa2f814e1d15e332d6cd0aa77e350972b0967d476f76546f6b656e",
  lq: "da8c30857834c6ae7203935b89278c532b3995245295456f993e1d244c51",
  opoc: "4ed5b703c146c25c09516f4b83aab31f44f7c55cdc159866e49731534f504f43",
  meh: "358e87af871fa88479b5e07f1744e2f866831f43a779e696ef945ee74d4548",
  block: "9d9ffb66370242f89e75cbed564d2d7b9b08eab35d9cc2ab5e25a844424c4f434b",
  adkash: "91fbce324827fcb04240e95772277225997fde8af6bfebd16b3f381c4469676974616c4b617368",
  mars: "9ff14600a3fdaee6da3b1e3d227e2235d1fad199c3691ba2c7d8665a4d415253"
}, b = {
  "": !0,
  "95a427e384527065f2f8946f5e86320d0117839a5e98ea2c0b55fb0048554e54": !0,
  f66d78b4a3cb3d37afa0ec36461e51ecbde00f26c8f0a68f94b6988069425443: !0,
  a3931691f5c4e65d01c429e473d0dd24c51afdb6daf88e632a6c1e516f7263666178746f6b656e: !0,
  c0ee29a85b13209423b10447d3c2e6a50641a15c57770e27cb9d507357696e67526964657273: !0,
  "8cfd6893f5f6c1cc954cec1a0a1460841b74da6e7803820dde62bb78524a56": !0,
  "8daefa391220bd0d8d007f3748d870f7f3c106040314c8515ccc35a5464c4143": !0,
  "9a9693a9a37912a5097918f97918d15240c92ab729a0b7c4aa144d7753554e444145": !0,
  "1ddcb9c9de95361565392c5bdff64767492d61a96166cb16094e54be4f5054": !0,
  "804f5544c1962a40546827cab750a88404dc7108c0f588b72964754f56594649": !0,
  da8c30857834c6ae7203935b89278c532b3995245295456f993e1d244c51: !0,
  "9abf0afd2f236a19f2842d502d0450cbcd9c79f123a9708f96fd9b96454e4353": !0,
  dda5fdb1002f7389b33e036b6afee82a8189becb6cba852e8b79b4fb0014df1047454e53: !0,
  "8db269c3ec630e06ae29f74bc39edd1f87c819f1056206e879a1cd615368656e4d6963726f555344": !0,
  f66d78b4a3cb3d37afa0ec36461e51ecbde00f26c8f0a68f94b6988069555344: !0,
  "25f0fc240e91bd95dcdaebd2ba7713fc5168ac77234a3d79449fc20c534f4349455459": !0,
  "8a1cfae21368b8bebbbed9800fec304e95cce39a2a57dc35e2e3ebaa4d494c4b": !0,
  "533bb94a8850ee3ccbe483106489399112b74c905342cb1792a797a0494e4459": !0,
  "279c909f348e533da5808898f87f9a14bb2c3dfbbacccd631d927a3f534e454b": !0,
  "29d222ce763455e3d7a09a665ce554f00ac89d2e99a1a83d267170c64d494e": !0,
  edfd7a1d77bcb8b884c474bdc92a16002d1fb720e454fa6e993444794e5458: !0,
  "5d16cc1a177b5d9ba9cfa9793b07e60f1fb70fea1f8aef064415d114494147": !0,
  a2944573e99d2ed3055b808eaa264f0bf119e01fc6b18863067c63e44d454c44: !0,
  "8fef2d34078659493ce161a6c7fba4b56afefa8535296a5743f6958741414441": !0,
  "1d7f33bd23d85e1a25d87d86fac4f199c3197a2f7afeb662a0f34e1e776f726c646d6f62696c65746f6b656e": !0,
  f43a62fdc3965df486de8a0d32fe800963589c41b38946602a0dc53541474958: !0
};
export {
  e as CARDANO_TOKEN,
  d as CARDANO_TOKEN_IDENTIFIER,
  c as DEFAULT_TOKEN,
  f as DEFAULT_TOKEN_LIST,
  a as DEFAULT_TOKEN_NAME_TO_ID_MAPPING,
  b as PRIORITY_TOKEN_IDS
};
